import { useEffect, useRef, useState } from "react";
import { Calendar, Dialog, InputNumber, InputTextarea, SelectButton, addLocale } from "primereact";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import useMessage from "../../Hooks/useMessage";
import { useApp, useAuthentication, useConfirm, useTheme } from "../../Hooks";
import useExceptionHandler from "../../Hooks/useExceptionHandler";
import { PagoTarjetaFormalizacionDialog } from "../PagoTarjetaCredito/PagoTarjetaFormalizacion";
import {
  descomponerTabletas,
  precioTabletas,
  integracionComernioElectronico,
  integracionesDgii,
  integracionesPanelFirma,
  integracionLinkPago,
  modulosAdi,
  otrasConfig,
  PLANES_ECF,
  PLANES_ECF_GESTION_NEGOCIO,
  USO_DATOS,
  USO_CORREOS_MEN,
  TERMINAL_TIPO_PT,
} from "../../Utils";
import { buscar } from "../../Utils/Buscar";
import EditSection from "../PantallasEdit/EditSection/EditSection";
import ToolTip from "../ToolTip/Tooltip";
import { SvgComponent } from "../SvgComponent/SvgComponent";
import Select from "react-select";
import { AnimatedIconButton } from "../AnimatedIconButton/AnimatedIconButton";
import "./ConfiguracionSection.css";
import {
  ACTULIZAR_COMPANIA,
  OBTENER_POLITICA_COBRO_MODIFICACION_COMPANIA,
  OBTENER_USO_DE_DATOS,
  OBTENER_USO_DE_CORREO_MEN,
  OBTENER_TOTAL_TERMINALES_ACTIVAS,
} from "../../../../Seguridad/Scripts/Utils/urls";

addLocale("es", {
  firstDayOfWeek: 1,
  dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
  today: "Hoy",
  clear: "Limpiar",
});

const COSTO_LICENCIA = 650;
const COSTO_LICENCIA_PT = 500;
const COSTO_MODULOS_ADICIONALES = 1000;
const COSTO_INTEGRACIONES = 500;

/**
 * Genera un UUID v4 compatible con navegadores antiguos.
 * Usa crypto.randomUUID() si está disponible, de lo contrario usa un fallback.
 * @returns {string} UUID en formato xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
function generarCodigoUnico() {
  // Usar crypto.randomUUID() si está disponible (navegadores modernos)
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  
  // Fallback para navegadores antiguos
  // Usa crypto.getRandomValues si está disponible para mejor aleatoriedad
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }
  
  // Fallback final usando Math.random() para navegadores muy antiguos
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function ConfiguracionCuenta({ showLoading, hideLoading, setCurrentTab }) {
  const [tipoPago, setTipoPago] = useState(0);
  const [panelFirma, setPanelFirma] = useState([]);
  const [comercioElec, setComercioElec] = useState([]);
  const [intDGII, setIntDGII] = useState([]);
  const [linkPago, setLinkPago] = useState([]);
  const [modulosAdicionales, setModulosAdicionales] = useState([]);
  const [configAdic, setConfigAdi] = useState([]);
  const [compania, setCompania] = useState({});
  const { theme } = useTheme();
  const { usuario, TIENE_PERMISO } = useAuthentication();
  const { Warning } = useMessage();
  const { handleException } = useExceptionHandler();
  const [usoDatos, setUsoDatos] = useState("");
  const [usoCorreoMen, setUsoCorreoMen] = useState("");
  const [editar, setEditar] = useState(false);
  const [tipoPlan, setTipoPlan] = useState(["1kT"]);
  const consultaActualId = useRef();
  const operacionCodigoUnicoRef = useRef(null);
  const [pagosUnicos, setPagosUnicos] = useState(0);
  const [descuentoCantidadLicencias, setDescuentoCantidadLicencias] = useState(0);
  const pt = {
    incrementButton: {
      style: {
        backgroundColor: theme.color1,
        border: theme.color1,
        color: "#ffffff",
        paddingTop: "4px",
        WebkitBorderTopRightRadius: "6px",
      },
    },
    decrementButton: {
      style: {
        backgroundColor: theme.color1,
        border: theme.color1,
        color: "#ffffff",
        WebkitBorderBottomRightRadius: "6px",
      },
    },
  };
  const { Confirm, Types } = useConfirm();

  const [subTotal, setSubtotal] = useState(0);
  const [totalLicencia, setTotalLicencia] = useState(0);
  const [totalModulos, setTotalModulos] = useState(0);
  const [totalIntegraciones, setTotalIntegraciones] = useState(0);
  const [montDescuentoReferencia, setMontoDescuentoReferencia] = useState(0);
  const [descuentoAnual, setDescuentoAnual] = useState(0);
  const [montoAnual, setMontoAnual] = useState(0);
  const [tipoPlanReferido, setTipoPlanReferido] = useState(1);
  let EsReferido = false;
  const [pagoModalVisible, setPagoModalVisible] = useState(false);

  const [licenciasERP, setLicenciasERP] = useState(0);
  const [licencasCRM, setLicenciasCRM] = useState(0);
  const [licenciasPT, setLicenciasPT] = useState(0);
  const licenciasActualesRef = useRef({ erp: 0, crm: 0, pt: 0 });
  const [companiaInicial, setCompaniaInicial] = useState(null);

  const [configInicial, setConfigInicial] = useState(null);
  const [newConfig, setNewConfig] = useState({});
  const [pagoExitoso, setPagoExitoso] = useState(false);
  const [value, setValue] = useState(0);
  const [valueCRM, setValueCRM] = useState(0);
  const [valuePT, setValuePT] = useState(0);

  // si es true aumenta sino disminuye
  const [opereacion, setOperacion] = useState(true);
  const [opereacionCRM, setOperacionCRM] = useState(true);
  const [opereacionPT, setOperacionPT] = useState(true);
  const dialogPagoRef = useRef();
  const [pagoAnual, setPagoAnual] = useState(false);
  const [modulosAdicionalesDiff, setModulosAdicionalesDiff] = useState([]);
  const [configuracionAdicionalDiff, setConfiguracionAdicionalDiff] = useState([]);
  const [intDGIIDiff, setIntDGIIDiff] = useState([]);
  const [comercioElecDiff, setComercioElecDiff] = useState([]);
  const [panelFirmaDiff, setPanelFirmaDiff] = useState([]);
  const [enlacePagoDiff, setEnlacePagoDiff] = useState([]);
  const [tipoPlanECFDiff, setTipoPlanECFDiff] = useState([]);
  const [color, setColor] = useState("#495057");
  const [colorCRM, setColorCRM] = useState("#495057");
  const [colorPT, setColorPT] = useState("#495057");

  const [clickPlusERP, setClickPlusERP] = useState(true);
  const [clickPlusCRM, setClickPlusCRM] = useState(true);
  const [clickPlusPT, setClickPlusPT] = useState(true);
  const [clickMinusERP, setClickMinusERP] = useState(false);
  const [clickMinusCRM, setClickMinusCRM] = useState(false);
  const [clickMinusPT, setClickMinusPT] = useState(false);

  const isFirstRun = useRef(true);
  const [totalConfigInicial, setTotalConfigInicial] = useState(0);
  const [tarjetaModalVisible, setTarjetaModalVisbile] = useState(false);
  const { configuration } = useApp();

  const [razonCancelacionModalVisible, setRazonCancelacionModalVisible] = useState(false);
  const mensajeCancelacionRef = useRef(null);
  const [pendingCancellationConfig, setPendingCancellationConfig] = useState(null);
  const [miCuentaProcessingVisible, setMiCuentaProcessingVisible] = useState(false);
  const [miCuentaProcessingPercent, setMiCuentaProcessingPercent] = useState(0);
  const [politicaCobro, setPoliticaCobro] = useState({
    FactorCobroRecurrente: 1,
    MesesCobro: 1,
    AplicaProrrateo: false,
    AplicaDescuentoAnual: false,
    ValidacionEmisorElectronicoRealizada: false,
    EsEmisorElectronico: false,
    CobrarImplementacionEcf: true,
  });
  const [estadoFacturacionElectronicaActual, setEstadoFacturacionElectronicaActual] = useState(null);

  const [ayudaComprobanteModalVisible, setAyudaComprobanteModalVisible] = useState(false);
  const dialogAyudaComprobanteRef = useRef();
  const [transferenciaBancariaModalVisible, setTransferenciaBancariaModalVisible] = useState(false);
  const dialogTransferenciaBancariaRef = useRef();
  const [tipoComprobante, setTipoComprobante] = useState("Transferencia");
  const [bancoEmisor, setBancoEmisor] = useState("");
  const [nombre, setNombre] = useState("");
  const [fechaTransferencia, setFechaTransferencia] = useState("");
  const [referencia, setReferencia] = useState("");
  const [archivoComprobante, setArchivoComprobante] = useState(null);
  const fileInputRef = useRef(null);

  const [planesEcf, setPlanesEcf] = useState(PLANES_ECF);
  const [tienePermiso, setTienePermiso] = useState(false);

  const [totalTabletas, setTotalTabletas] = useState(0);
  const [valueTabletas, setValueTabletas] = useState(0);
  const [opereacionTabletas, setOperacionTabletas] = useState(true);

  const [modulosEliminados, setModulosEliminados] = useState([]);
  useEffect(() => {
    setPlanesEcf(configuration?.Vendor === "claro" ? PLANES_ECF_GESTION_NEGOCIO : PLANES_ECF);
  }, [configuration]);

  const editarAnteriorRef = useRef(false);
  useEffect(() => {
    if (usuario) {
      const yaEstabaEditando = editarAnteriorRef.current;
      editarAnteriorRef.current = editar;
      
      if (editar && yaEstabaEditando) {
        return;
      }
      const compania = {
        ...usuario.Compania,
        Configuracion: { ...(usuario.Compania.Configuracion ?? {}) },
      };
      setCompania(compania);
      setCompaniaInicial(compania);
      licenciasActualesRef.current = {
        erp: compania.CantidadUsuarios ?? 0,
        crm: compania.CantidadUsuariosCRM ?? 0,
        pt: compania.CantidadUsuariosPT ?? 0,
      };
      let panelFirmaValue = null;
      if (compania.Configuracion?.UsaModuloVisaNet) {
        panelFirmaValue = 2;
      } else if (compania.Configuracion?.UsaModuloCardNet) {
        panelFirmaValue = 1;
      } else if (compania.Configuracion?.UsaModuloAzul) {
        panelFirmaValue = 3;
      }
      setPanelFirma([panelFirmaValue]);

      let comercioElecValue = [];
      if (compania.UsaShopify) {
        comercioElecValue.push(2);
      }
      if (compania.UsaWooCommerce) {
        comercioElecValue.push(1);
      }
      if (compania.UsaMiniHotel) {
        comercioElecValue.push(3);
      }
      setComercioElec(comercioElecValue);

      let intDGIIValue = null;
      if (compania.UsaFacturacionElectronica) {
        intDGIIValue = 1;
      } else if (compania.Configuracion?.UsaImpresoraFiscal) {
        intDGIIValue = 2;
      }
      setIntDGII([intDGIIValue]);

      let tipoPlanECF = null;
      if (intDGIIValue === 1) {
        const planValue = planesEcf.find((plan) => plan.label === compania.TipoPlanECF)?.value;
        compania._TipoPlanEcf = planValue;
        tipoPlanECF = planValue;
        setTipoPlan([tipoPlanECF]);
      }

      let linkPagoValue = [];
      if (compania.UsaEnlacePago) {
        linkPagoValue.push(1);
      }
      if (compania.UsaAzulLinkPago) {
        linkPagoValue.push(2);
      }
      setLinkPago(linkPagoValue);

      let modulosAdicionalesValue = [];
      if (compania.UsaNomina) {
        modulosAdicionalesValue.push(1);
      }
      if (compania.Configuracion?.UsaConsulta) {
        modulosAdicionalesValue.push(2);
      }
      if (compania.UsaFactoring) {
        modulosAdicionalesValue.push(3);
      }
      if (compania.UsaRestaurante) {
        modulosAdicionalesValue.push(4);
      }
      if (compania.UsaPrestamo) {
        modulosAdicionalesValue.push(5);
      }
      if (compania.UsaProduccion) {
        modulosAdicionalesValue.push(6);
      }
      setModulosAdicionales(modulosAdicionalesValue);

      let otrasConfigValue = [];
      if (compania.UsaCaja) {
        otrasConfigValue.push(1);
      }
      if (compania.UsaCentro) {
        otrasConfigValue.push(2);
      }
      let totalTabletasInicial = 0;
      if (compania.UsaRestaurante) {
        totalTabletasInicial = parseInt(compania.CantidadDispositivosAdicionalesRestaurante, 10) || 0;
        setTotalTabletas(totalTabletasInicial);
        setValueTabletas(0);
        setOperacionTabletas(true);
      }
      setConfigAdi(otrasConfigValue);
      setLicenciasERP(compania.CantidadUsuarios ?? 0);
      setLicenciasCRM(compania.CantidadUsuariosCRM ?? 0);
      setLicenciasPT(compania.CantidadUsuariosPT ?? 0);

      let configInicial = {
        licenciasERP: compania.CantidadUsuarios,
        licencasCRM: compania.CantidadUsuariosCRM,
        licenciasPT: compania.CantidadUsuariosPT ?? 0,
        otrasConfig: otrasConfigValue,
        modulosAdicionales: modulosAdicionalesValue,
        linkPago: linkPagoValue,
        intDGII: [intDGIIValue],
        comercioElec: comercioElecValue,
        panelFirma: [panelFirmaValue],
        tipoPlanECF: [tipoPlanECF],
        totalTabletas: totalTabletasInicial,
      };
      setConfigInicial(configInicial);
      setNewConfig(configInicial);
      setTienePermiso(
        TIENE_PERMISO("Citrus.Seguridad.MiCuenta.Visualizar") || compania?.Configuracion?.EsCompaniaPrueba
      );
    }
  }, [usuario, editar]);

  useEffect(() => {
    if (!usuario) {
      return;
    }

    buscar(OBTENER_POLITICA_COBRO_MODIFICACION_COMPANIA, {})
      .then((data) => {
        setPoliticaCobro({
          ...data,
          FactorCobroRecurrente: Number(data?.FactorCobroRecurrente ?? 1) || 1,
          MesesCobro: Number(data?.MesesCobro ?? 1) || 1,
        });
        setEstadoFacturacionElectronicaActual({
          companiaId: usuario.Compania?.Id,
          disponible: true,
          activa: data?.UsaFacturacionElectronicaActual === true,
          tipoPlanEcf: data?.TipoPlanEcfActual ?? null,
        });
      })
      .catch(() => {
        setPoliticaCobro({
          FactorCobroRecurrente: 1,
          MesesCobro: 1,
          AplicaProrrateo: false,
          AplicaDescuentoAnual: false,
          ValidacionEmisorElectronicoRealizada: false,
          EsEmisorElectronico: false,
          CobrarImplementacionEcf: true,
        });
        setEstadoFacturacionElectronicaActual({
          companiaId: usuario.Compania?.Id,
          disponible: false,
        });
      });
  }, [usuario]);

  useEffect(() => {
    if (
      !usuario ||
      estadoFacturacionElectronicaActual?.companiaId !== usuario.Compania?.Id ||
      !estadoFacturacionElectronicaActual.disponible
    ) {
      return;
    }

    const activa = estadoFacturacionElectronicaActual.activa;
    const planActual = activa ? estadoFacturacionElectronicaActual.tipoPlanEcf : null;
    const integracionDgiiActual = activa ? 1 : usuario.Compania?.Configuracion?.UsaImpresoraFiscal ? 2 : null;
    const reconciliarCompania = (companiaActual) => ({
      ...companiaActual,
      UsaFacturacionElectronica: activa,
      _usaFacturacionElectronica: activa,
      _TipoPlanEcf: planActual,
    });
    const reconciliarConfiguracion = (configuracionActual) => ({
      ...(configuracionActual ?? {}),
      intDGII: [integracionDgiiActual],
      tipoPlanECF: [planActual],
    });

    setCompania(reconciliarCompania);
    setCompaniaInicial(reconciliarCompania);
    setIntDGII([integracionDgiiActual]);
    setTipoPlan([planActual]);
    setConfigInicial(reconciliarConfiguracion);
    setNewConfig(reconciliarConfiguracion);
  }, [editar, estadoFacturacionElectronicaActual, usuario]);

  useEffect(() => {
    setTimeout(
      () => {
        const element2 = document.querySelectorAll(".p-button.p-component");
        if (element2.length > 0) {
          element2.forEach((map) => {
            if (map.nodeName !== "BUTTON") {
              map.style.backgroundColor = "unset";
            }
          });
        }
        const element = document.querySelectorAll(".p-button.p-component.p-highlight");
        if (element.length > 0) {
          element.forEach((map) => {
            map.style.backgroundColor = theme.color1T;
          });
        }
      },
      pagoModalVisible ? 50 : 0
    );
  }, [configAdic, compania, tipoPago, pagoModalVisible]);

  useEffect(() => {
    const consultaIdDatos = Math.random();
    const consultaIdCorreo = Math.random();
    consultaActualId.current = { datos: consultaIdDatos, correo: consultaIdCorreo };

    buscar(OBTENER_USO_DE_DATOS, {})
      .then((data) => {
        if (consultaIdDatos === consultaActualId.current?.datos) {
          setUsoDatos(data.totalUsoDatos);
        }
      })
      .catch((error) => {
        handleException(error);
      });

    buscar(OBTENER_USO_DE_CORREO_MEN, {})
      .then((data) => {
        if (consultaIdCorreo === consultaActualId.current?.correo) {
          setUsoCorreoMen(data.totalUsoCorroMensual);
        }
      })
      .catch((error) => {
        handleException(error);
      });
  }, []);

  const Editar = () => {
    if (estadoFacturacionElectronicaActual?.companiaId !== usuario?.Compania?.Id) {
      return;
    }
    if (!tienePermiso) {
      Warning({ message: "Usuario no tiene este permiso" });
      return;
    }
    if (!compania.cliente && !compania.Configuracion?.EsCompaniaPrueba) {
      Warning({
        message: "Esta Compañía está mal configurada. Contacte con el Administrador para continuar el proceso.",
      });
      return;
    }
    if (!editar) {
      setValue(0);
      setValueCRM(0);
      setValuePT(0);
      setOperacion(true);
      setOperacionCRM(true);
      setOperacionPT(true);
      setSubtotal(0);
      setPagosUnicos(0);
      setTotalLicencia(0);
      setTotalModulos(0);
      setTotalIntegraciones(0);
    }
    setEditar(!editar);
    setCompania(companiaInicial);
  };
  const getStatus = (mod, newConfigArray, initialConfigArray) => {
    if (newConfigArray?.includes(mod.value) && !initialConfigArray?.includes(mod.value)) {
      return { value: mod.value, status: "A" };
    } else if (!newConfigArray?.includes(mod.value) && initialConfigArray?.includes(mod.value)) {
      return { value: mod.value, status: "E" };
    } else if (newConfigArray?.includes(mod.value) && initialConfigArray?.includes(mod.value)) {
      return { value: mod.value, status: "N" };
    }
    return null;
  };
  const processConfigs = (modules, newConfigArray, initialConfigArray) => {
    return modules.map((mod) => getStatus(mod, newConfigArray, initialConfigArray)).filter(Boolean);
  };

  useEffect(() => {
    if (!configInicial) {
      setModulosAdicionalesDiff([]);
      setIntDGIIDiff([]);
      setComercioElecDiff([]);
      setPanelFirmaDiff([]);
      setEnlacePagoDiff([]);
      setConfiguracionAdicionalDiff([]);
      setTipoPlanECFDiff([]);
      return;
    }
    setModulosAdicionalesDiff(
      processConfigs(modulosAdi, newConfig?.modulosAdicionales, configInicial?.modulosAdicionales)
    );
    setIntDGIIDiff(processConfigs(integracionesDgii, newConfig?.intDGII, configInicial?.intDGII));
    setComercioElecDiff(
      processConfigs(integracionComernioElectronico, newConfig?.comercioElec, configInicial?.comercioElec)
    );
    setPanelFirmaDiff(processConfigs(integracionesPanelFirma, newConfig?.panelFirma, configInicial?.panelFirma));
    setEnlacePagoDiff(processConfigs(integracionLinkPago, newConfig?.linkPago, configInicial?.linkPago));
    setConfiguracionAdicionalDiff(processConfigs(otrasConfig, newConfig?.otrasConfig, configInicial?.otrasConfig));
    setTipoPlanECFDiff(processConfigs(planesEcf, newConfig?.tipoPlanECF, configInicial?.tipoPlanECF));
  }, [newConfig, configInicial]);

  useEffect(() => {
    if (!editar || !configInicial) {
      return;
    }
    calculateTotal(pagoAnual, false);
  }, [
    editar,
    pagoAnual,
    opereacion,
    opereacionPT,
    opereacionCRM,
    value,
    valuePT,
    valueCRM,
    modulosAdicionalesDiff,
    intDGIIDiff,
    comercioElecDiff,
    panelFirmaDiff,
    enlacePagoDiff,
    tipoPlanECFDiff,
    intDGII,
    panelFirma,
    tipoPlan,
    totalTabletas,
    valueTabletas,
    opereacionTabletas,
    politicaCobro?.FactorCobroRecurrente,
    politicaCobro?.CobrarImplementacionEcf,
  ]);

  useEffect(() => {
    if (!miCuentaProcessingVisible) {
      setMiCuentaProcessingPercent(0);
      return undefined;
    }

    const timer = window.setInterval(() => {
      setMiCuentaProcessingPercent((value) => {
        const increment = value < 36 ? 5 : value < 68 ? 3 : value < 88 ? 1.4 : 0.35;
        return Math.min(96, value + increment);
      });
    }, 240);

    return () => window.clearInterval(timer);
  }, [miCuentaProcessingVisible]);

  useEffect(() => {
    if (licenciasERP + value > compania?.CantidadUsuarios) {
      setColor("green");
    } else if (licenciasERP - value < compania?.CantidadUsuarios) {
      setColor("red");
    } else {
      setColor("#495057");
    }
  }, [licenciasERP]);
  useEffect(() => {
    if (licencasCRM + valueCRM > compania?.CantidadUsuariosCRM) {
      setColorCRM("green");
    } else if (licencasCRM - valueCRM < compania?.CantidadUsuariosCRM) {
      setColorCRM("red");
    } else {
      setColorCRM("#495057");
    }
  }, [licencasCRM]);

  useEffect(() => {
    let usuariosPTActuales = compania?.CantidadUsuariosPT ?? 0;
    if (licenciasPT + valuePT > usuariosPTActuales) {
      setColorPT("green");
    } else if (licenciasPT - valuePT < usuariosPTActuales) {
      setColorPT("red");
    } else {
      setColorPT("#495057");
    }
  }, [licenciasPT]);

  const redireccionarProcesoCompletado = (redirect) => {
    const destino = redirect
      ? redirect.replace(/^~/, "")
      : "/Public/pantalla_pago_exitoso.aspx?app=1&origen=mi-cuenta";
    window.location.href = destino;
  };

  function validarLicencias() {
    const cancelacionesEfectivas = getCancelacionesEfectivas();
    if (cancelacionesEfectivas.length && !mensajeCancelacionRef?.current?.value?.trim()) {
      const modulosRetirados = obtenerModulosRetirados();
      const companiaConCancelacionesEfectivas = aplicarCancelacionesForzadasACompania(compania);
      const cancellationConfig = getCancellationConfig(companiaConCancelacionesEfectivas, "aceptar", modulosRetirados);
      setModulosEliminados(modulosRetirados);
      setPendingCancellationConfig(cancellationConfig);
      setRazonCancelacionModalVisible(true);
      return;
    }

    const obtenerDatos = () => {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;

      const url = OBTENER_TOTAL_TERMINALES_ACTIVAS;
      buscar(url, { tipo: TERMINAL_TIPO_PT }).then((data) => {
        if (consultaId === consultaActualId.current) {
          if (newConfig.licenciasPT < data.TotalTerminalesActivas) {
            Confirm({
              type: Types.TYPE_DEFAULT,
              title: `Terminales excedentes`,
              textBody: `Tiene menos licencias que dispositivos vinculados.\nDebe desvincular los dispositivos que exceden las licencias.`,
              onConfirm: () => {
                window.open("/TerminalPos/terminal_pos_list.aspx", "_blank");
              },
              onCancel: () => {},
              confirmBtnText: "Desvincular",
              cancelBtnText: "Cancelar",
            });
          } else {
            const totalesCalculados = calculateTotal(pagoAnual, false);
            const totalPendienteCalculado = totalesCalculados?.totalPendiente ?? subTotal + pagosUnicos + pagosUnicos * 0.18;
            if (totalPendienteCalculado > 0) {
              if (tipoPago === 0) {
                setTarjetaModalVisbile(true);
              } else if (tipoPago === 1) {
                enviarComprobanteTransferencia();
              }
            } else {
              ActualizarCompania();
            }
          }
        }
      });
    };
    obtenerDatos();
  }

  function ActualizarCompania(comprobanteTransferencia = null) {
    setPagoModalVisible(false);
    setRazonCancelacionModalVisible(false);
    setMiCuentaProcessingVisible(true);
    const consultaId = Math.random();
    consultaActualId.current = consultaId;
    if (!operacionCodigoUnicoRef.current) {
      operacionCodigoUnicoRef.current = generarCodigoUnico();
    }
    const codigoUnicoOperacion = operacionCodigoUnicoRef.current;
    let redireccionando = false;
    const url = ACTULIZAR_COMPANIA;
    const companiaEnvio = aplicarCancelacionesForzadasACompania(compania);
    let cantidadDispRestaurante = null;
    if (compania?._usaRestaurante ?? compania?.UsaRestaurante ?? false) {
      cantidadDispRestaurante = totalTabletas > 0 ? String(totalTabletas) : null;
    }
    buscar(url, {
      newCompania: {
        _usaFacturacionElectronica: compania?._usaFacturacionElectronica ?? compania.UsaFacturacionElectronica ?? false,
        _UsaVisaNet: compania?._UsaVisaNet ?? compania.Configuracion?.UsaModuloVisaNet ?? false,
        _UsaAzul: compania?._UsaAzul ?? compania.Configuracion?.UsaModuloAzul ?? false,
        _UsaImpresoraFiscal: compania?._UsaImpresoraFiscal ?? compania.Configuracion?.UsaImpresoraFiscal ?? false,
        _UsaShopify: compania?._UsaShopify ?? compania.UsaShopify ?? false,
        _UsaWooCommerce: compania?._UsaWooCommerce ?? compania.UsaWooCommerce ?? false,
        _UsaCardNetEnLinea: compania?._UsaCardNetEnLinea ?? compania.UsaEnlacePago ?? false,
        _UsaAzulLinkPago: compania?._UsaAzulLinkPago ?? compania.UsaAzulLinkPago ?? false,
        _UsaCardNet: compania?._UsaCardNet ?? compania.Configuracion?.UsaModuloCardNet ?? false,
        _UsaFactoring: compania?._UsaFactoring ?? compania.UsaFactoring ?? false,
        _UsaConsulta: compania?._UsaConsulta ?? compania.Configuracion?.UsaConsulta ?? false,
        _UsaNomina: compania?._UsaNomina ?? compania.UsaNomina ?? false,
        _UsaCentro: compania?._UsaCentro ?? compania.UsaCentro ?? false,
        _UsaCaja: compania?._UsaCaja ?? compania.UsaCaja ?? false,
        _TipoPlanEcf: compania?._TipoPlanEcf ?? compania.TipoPlanECF ?? "",
        licenciasCRM: licencasCRM,
        licenciasERP: licenciasERP,
        licenciasPT: licenciasPT,
        CantidadLicenciasERP: value,
        CantidadLicenciasCRM: valueCRM,
        CantidadLicenciasPT: valuePT,
        CancelarERP: companiaEnvio?.CancelarERP ?? false,
        CancelarCRM: companiaEnvio?.CancelarCRM ?? false,
        CancelarPT: companiaEnvio?.CancelarPT ?? false,
        RazonCancelacion: mensajeCancelacionRef?.current?.value ?? "",
        _UsaMiniHotel: compania?._UsaMiniHotel ?? compania.UsaMiniHotel ?? false,
        _usaRestaurante: compania?._usaRestaurante ?? compania?.UsaRestaurante ?? false,
        _usaPrestamo: compania?._usaPrestamo ?? compania?.UsaPrestamo ?? false,
        _UsaProduccion: compania?._UsaProduccion ?? compania?.UsaProduccion ?? false,
        _CantidadDispositivosAdicionalesRestaurante: cantidadDispRestaurante,
        _CodigoUnico: codigoUnicoOperacion,
        _TipoPagoCliente: tipoPago,
        ComprobanteMontoTotal: `${subTotal + pagosUnicos + pagosUnicos * 0.18}`,
        ...(comprobanteTransferencia ?? {}),
      },
    })
      .then((data) => {
        if (consultaId === consultaActualId.current) {
          redireccionando = true;
          redireccionarProcesoCompletado(data.redirect);
        }
      })
      .catch((error) => {
        setMiCuentaProcessingVisible(false);
        handleException(error);
        if (
          error.Mensaje ===
          "Para Cancelar su Servicio debe saldar el Balance Pendiente. Ante cualquier duda o inquietud comuníquese con nosotros al (809) 548-8274 o al correo pagos@citrus.com.do"
        ) {
          setCurrentTab("log");
        }
      })
      .finally(() => {
        if (!redireccionando && consultaId === consultaActualId.current) {
          setMiCuentaProcessingVisible(false);
        }
      });
  }

  const PagoBody = () => {
    return (
      <div className="bootstrapiso mi-cuenta-config-modal">
        <Row>
          <Col>
            <EditSection title="Configuración anterior">
              <div className="list-group" style={{ marginBottom: "15px" }}>
                {compania?.CantidadUsuarios > 0 && (
                  <a href="#" className="list-group-item list-group-item-action">
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                        x{compania?.CantidadUsuarios} Licencias ERP
                      </h5>

                      <small>
                        RD${" "}
                        {
                          // eslint-disable-next-line no-undef
                          Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA * compania?.CantidadUsuarios)
                        }
                      </small>
                    </div>
                  </a>
                )}
                {compania?.CantidadUsuariosPT > 0 && (
                  <a href="#" className="list-group-item list-group-item-action">
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                        x{compania?.CantidadUsuariosPT} Licencias PT
                      </h5>
                      <small>
                        RD${" "}
                        {
                          // eslint-disable-next-line no-undef
                          Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA_PT * compania?.CantidadUsuariosPT)
                        }
                      </small>
                    </div>
                  </a>
                )}
                {compania?.CantidadUsuariosCRM > 0 && (
                  <a href="#" className="list-group-item list-group-item-action">
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                        x{compania?.CantidadUsuariosCRM} Licencias CRM
                      </h5>
                      <small>
                        RD${" "}
                        {
                          // eslint-disable-next-line no-undef
                          Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA * compania?.CantidadUsuariosCRM)
                        }
                      </small>
                    </div>
                  </a>
                )}
                {configInicial?.modulosAdicionales?.map((modulo) => {
                  const selectedModulo = modulosAdi.find((mod) => mod.value === modulo);
                  if (selectedModulo) {
                    return (
                      <a href="#" className="list-group-item list-group-item-action" key={selectedModulo.value}>
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                            Modulo {selectedModulo.name}
                          </h5>
                          <small>
                            RD${" "}
                            {
                              // eslint-disable-next-line no-undef
                              Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)
                            }
                          </small>
                        </div>
                      </a>
                    );
                  } else {
                    return null;
                  }
                })}
                {configInicial?.intDGII?.map((modulo) => {
                  const selectedModulo = integracionesDgii.find((mod) => mod.value === modulo);
                  if (selectedModulo && selectedModulo?.value === 2) {
                    return (
                      <>
                        <a href="#" className="list-group-item list-group-item-action" key={selectedModulo.value}>
                          <div className="d-flex w-100 justify-content-between">
                            <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                              Integracion {selectedModulo.name}
                              {selectedModulo.value === 1 && <small className="text-muted">Pago unico</small>}
                            </h5>
                            <small>
                              RD${" "}
                              {
                                // eslint-disable-next-line no-undef
                                Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)
                              }
                            </small>
                          </div>
                        </a>
                      </>
                    );
                  } else {
                    return null;
                  }
                })}
                {configInicial?.tipoPlanECF?.map((tipo) => {
                  const selectedModulo = planesEcf.find((mod) => mod.value === tipo);
                  if (selectedModulo && configInicial?.intDGII[0] === 1) {
                    return (
                      <a href="#" className="list-group-item list-group-item-action" key={selectedModulo.value}>
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                            Plan de {selectedModulo.label} <small className="text-muted">Facturación Electrónica</small>
                          </h5>
                          <small>
                            RD${" "}
                            {
                              // eslint-disable-next-line no-undef
                              Citrus.Convert.toCurrencyNoSimbolo(selectedModulo.precio)
                            }
                          </small>
                        </div>
                      </a>
                    );
                  } else {
                    return null;
                  }
                })}
                {configInicial?.comercioElec?.map((modulo) => {
                  const selectedModulo = integracionComernioElectronico.find((mod) => mod.value === modulo);
                  if (selectedModulo) {
                    return (
                      <a href="#" className="list-group-item list-group-item-action" key={selectedModulo.value}>
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                            Integracion {selectedModulo.name}
                          </h5>
                          <small>
                            RD${" "}
                            {
                              // eslint-disable-next-line no-undef
                              Citrus.Convert.toCurrencyNoSimbolo(COSTO_INTEGRACIONES)
                            }
                          </small>
                        </div>
                      </a>
                    );
                  } else {
                    return null;
                  }
                })}
                {configInicial?.panelFirma?.map((modulo) => {
                  const selectedModulo = integracionesPanelFirma.find((mod) => mod.value === modulo);
                  if (selectedModulo) {
                    return (
                      <>
                        <a href="#" className="list-group-item list-group-item-action" key={selectedModulo.value}>
                          <div className="d-flex w-100 justify-content-between">
                            <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                              Panel de firma {selectedModulo.name}
                            </h5>
                            <small>
                              RD${" "}
                              {
                                // eslint-disable-next-line no-undef
                                Citrus.Convert.toCurrencyNoSimbolo(COSTO_INTEGRACIONES)
                              }
                            </small>
                          </div>
                        </a>
                      </>
                    );
                  } else {
                    return null;
                  }
                })}
                {configInicial?.linkPago?.map((modulo) => {
                  const selectedModulo = integracionLinkPago.find((mod) => mod.value === modulo);
                  if (selectedModulo) {
                    return (
                      <a href="#" className="list-group-item list-group-item-action" key={selectedModulo.value}>
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                            Integracion {selectedModulo.name}
                          </h5>
                          <small>
                            RD${" "}
                            {
                              // eslint-disable-next-line no-undef
                              Citrus.Convert.toCurrencyNoSimbolo(COSTO_INTEGRACIONES)
                            }
                          </small>
                        </div>
                      </a>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            </EditSection>
          </Col>
          <Col>
            <EditSection title="Nueva configuración">
              <div className="list-group">
                {licenciasERP > 0 && (
                  <a
                    href="#"
                    className="list-group-item list-group-item-action"
                    style={{
                      color: color,
                      background:
                        color === "green" ? "rgb(0,255,0, 0.1)" : color === "red" ? "rgb(255,0,0, 0.1)" : "transparent",
                    }}
                  >
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                        {licenciasERP + value > compania?.CantidadUsuarios
                          ? `+${value}  x${licenciasERP} Licencias ERP`
                          : licenciasERP - value < compania?.CantidadUsuarios
                          ? `-${value} x${licenciasERP} Licencias ERP`
                          : `x${licenciasERP} Licencias ERP`}
                      </h5>
                      <small style={{ color: color !== "green" && color !== "red" ? "#999" : color }}>
                        RD${" "}
                        {
                          // eslint-disable-next-line no-undef
                          Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA * licenciasERP)
                        }
                      </small>
                    </div>
                  </a>
                )}
                {(licenciasPT > 0 || (compania?.CantidadUsuariosPT ?? 0) > 0) && (
                  <a
                    href="#"
                    className="list-group-item list-group-item-action"
                    style={{
                      color: colorPT,
                      background:
                        colorPT === "green"
                          ? "rgb(0,255,0, 0.1)"
                          : colorPT === "red"
                          ? "rgb(255,0,0, 0.1)"
                          : "transparent",
                    }}
                  >
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                        {licenciasPT + valuePT > (compania?.CantidadUsuariosPT ?? 0)
                          ? `+${valuePT}  x${licenciasPT} Licencias PT`
                          : licenciasPT - valuePT < (compania?.CantidadUsuariosPT ?? 0)
                          ? `-${valuePT} x${licenciasPT} Licencias PT`
                          : `x${licenciasPT} Licencias PT`}
                      </h5>
                      <small style={{ color: colorPT !== "green" && colorPT !== "red" ? "#999" : colorPT }}>
                        RD${" "}
                        {
                          // eslint-disable-next-line no-undef
                          Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA_PT * licenciasPT)
                        }
                      </small>
                    </div>
                  </a>
                )}
                {licencasCRM > 0 && (
                  <a
                    href="#"
                    className="list-group-item list-group-item-action"
                    style={{
                      color: colorCRM,
                      background:
                        colorCRM === "green"
                          ? "rgb(0,255,0, 0.1)"
                          : colorCRM === "red"
                          ? "rgb(255,0,0, 0.1)"
                          : "transparent",
                    }}
                  >
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                        {licencasCRM + valueCRM > compania?.CantidadUsuariosCRM
                          ? `+${valueCRM}  x${licencasCRM} Licencias CRM`
                          : licencasCRM - valueCRM < compania?.CantidadUsuariosCRM
                          ? `-${valueCRM} x${licencasCRM} Licencias CRM`
                          : `x${licencasCRM} Licencias CRM`}
                      </h5>
                      <small style={{ color: colorCRM !== "green" && colorCRM !== "red" ? "#999" : colorCRM }}>
                        RD${" "}
                        {
                          // eslint-disable-next-line no-undef
                          Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA * licencasCRM)
                        }
                      </small>
                    </div>
                  </a>
                )}
                {modulosAdicionalesDiff?.map((modulo) => {
                  const selectedModulo = modulosAdi.find((mod) => mod.value === modulo.value);
                  if (selectedModulo) {
                    let color;
                    if (modulo.status === "N") {
                      color = "#495057";
                    } else if (modulo.status === "E") {
                      color = "red";
                    } else if (modulo.status === "A") {
                      color = "green";
                    }
                    return (
                      <a
                        href="#"
                        className="list-group-item list-group-item-action"
                        key={selectedModulo.value}
                        style={{
                          color: color,
                          background:
                            color === "green"
                              ? "rgb(0,255,0, 0.1)"
                              : color === "red"
                              ? "rgb(255,0,0, 0.1)"
                              : "transparent",
                        }}
                      >
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                            {color === "green"
                              ? `+ Modulo ${selectedModulo.name}`
                              : color === "red"
                              ? `- Modulo ${selectedModulo.name}`
                              : `Modulo ${selectedModulo.name}`}
                            {selectedModulo.value === 4 && (
                              <>
                                <small className="text-muted">â€¢ Pt camarero: 2 tabletas </small>
                                <small className="text-muted">â€¢ Servicio de Impresion: 1 estacion</small>
                              </>
                            )}
                          </h5>
                          <small style={{ color: color === "green" || color === "red" ? color : "#999" }}>
                            RD${" "}
                            {
                              // eslint-disable-next-line no-undef
                              Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)
                            }
                          </small>
                        </div>
                      </a>
                    );
                  } else {
                    return null;
                  }
                })}
                {opereacionTabletas &&
                  valueTabletas > 0 &&
                  descomponerTabletas(valueTabletas).map((linea) => (
                    <a
                      href="#"
                      className="list-group-item list-group-item-action"
                      key={`tableta-${linea.cantidad}`}
                      style={{ color: "green", background: "rgb(0,255,0, 0.1)" }}
                    >
                      <div className="d-flex w-100 justify-content-between">
                        <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                          {linea.veces > 1 ? `${linea.name} (${linea.veces})` : linea.name}{" "}
                          <small className="text-muted">Tabletas adicionales</small>
                        </h5>
                        <small style={{ color: "green" }}>
                          RD${" "}
                          {
                            // eslint-disable-next-line no-undef
                            Citrus.Convert.toCurrencyNoSimbolo(linea.precio * linea.veces)
                          }
                        </small>
                      </div>
                    </a>
                  ))}

                {intDGIIDiff?.map((modulo) => {
                  const selectedModulo = integracionesDgii.find((mod) => mod.value === modulo.value);
                  if (selectedModulo) {
                    let color;
                    if (modulo.status === "N") {
                      color = "#495057";
                    } else if (modulo.status === "E") {
                      color = "red";
                    } else if (modulo.status === "A") {
                      color = "green";
                    }
                    return (
                      <>
                        {selectedModulo.value === 1 && (modulo.status === "E" || modulo.status === "N") ? (
                          <></>
                        ) : (
                          <a
                            href="#"
                            className="list-group-item list-group-item-action"
                            key={selectedModulo.value}
                            style={{
                              color: color,
                              background:
                                color === "green"
                                  ? "rgb(0,255,0, 0.1)"
                                  : color === "red"
                                  ? "rgb(255,0,0, 0.1)"
                                  : "transparent",
                            }}
                          >
                            <div className="d-flex w-100 justify-content-between">
                              <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                                {color === "green" ? (
                                  <>
                                    + Integracion {selectedModulo.name}{" "}
                                    {selectedModulo.value === 1 && (
                                      <small style={{ color: "green" }} className="text-muted">
                                        Pago unico
                                      </small>
                                    )}
                                  </>
                                ) : color === "red" && selectedModulo.value === 1 ? (
                                  <>
                                    - Integracion {selectedModulo.name}{" "}
                                    {selectedModulo.value === 1 && (
                                      <small style={{ color: "green" }} className="text-muted">
                                        Pago unico
                                      </small>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    Integracion {selectedModulo.name}{" "}
                                    {selectedModulo.value === 1 && (
                                      <small style={{ color: "green" }} className="text-muted">
                                        Pago unico
                                      </small>
                                    )}
                                  </>
                                )}
                              </h5>
                              {selectedModulo.value === 1 ? (
                                <small style={{ color: color === "green" || color === "red" ? color : "#999" }}>
                                  RD${" "}
                                  {
                                    // eslint-disable-next-line no-undef
                                    Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES * 10)
                                  }
                                </small>
                              ) : (
                                <small style={{ color: color === "green" || color === "red" ? color : "#999" }}>
                                  RD${" "}
                                  {
                                    // eslint-disable-next-line no-undef
                                    Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)
                                  }
                                </small>
                              )}
                            </div>
                          </a>
                        )}
                        {selectedModulo.value === 2 && modulo.status === "A" && (
                          <a
                            href="#"
                            className="list-group-item list-group-item-action"
                            key={selectedModulo.value}
                            style={{
                              color: color,
                              background:
                                color === "green"
                                  ? "rgb(0,255,0, 0.1)"
                                  : color === "red"
                                  ? "rgb(255,0,0, 0.1)"
                                  : "transparent",
                            }}
                          >
                            <div className="d-flex w-100 justify-content-between">
                              <h5
                                className="mb-1"
                                style={{ width: "70%", display: "flex", flexDirection: "column", color: "green" }}
                              >
                                + Instalacion remota {selectedModulo.name}{" "}
                                <small className="text-muted">Pago unico</small>
                              </h5>
                              <small style={{ color: "green" }}>
                                RD$
                                {
                                  // eslint-disable-next-line no-undef
                                  Citrus.Convert.toCurrencyNoSimbolo(4000)
                                }
                              </small>
                            </div>
                          </a>
                        )}
                      </>
                    );
                  } else {
                    return null;
                  }
                })}
                {tipoPlanECFDiff.map((tipo) => {
                  const selectedModulo = planesEcf.find((mod) => mod.value === tipo.value);
                  if (selectedModulo) {
                    let color;
                    if (tipo.status === "N") {
                      color = "#495057";
                    } else if (tipo.status === "E") {
                      color = "red";
                    } else if (tipo.status === "A") {
                      color = "green";
                    }
                    return (
                      <a
                        href="#"
                        className="list-group-item list-group-item-action"
                        key={selectedModulo.value}
                        style={{
                          color: color,
                          background:
                            color === "green"
                              ? "rgb(0,255,0, 0.1)"
                              : color === "red"
                              ? "rgb(255,0,0, 0.1)"
                              : "transparent",
                        }}
                      >
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                            Plan de {selectedModulo.label} <small className="text-muted">Facturación Electrónica</small>
                          </h5>
                          <small style={{ color: color === "green" || color === "red" ? color : "#999" }}>
                            RD${" "}
                            {
                              // eslint-disable-next-line no-undef
                              Citrus.Convert.toCurrencyNoSimbolo(selectedModulo.precio)
                            }
                          </small>
                        </div>
                      </a>
                    );
                  } else {
                    return null;
                  }
                })}
                {comercioElecDiff?.map((modulo) => {
                  const selectedModulo = integracionComernioElectronico.find((mod) => mod.value === modulo.value);
                  if (selectedModulo) {
                    let color;
                    if (modulo.status === "N") {
                      color = "#495057";
                    } else if (modulo.status === "E") {
                      color = "red";
                    } else if (modulo.status === "A") {
                      color = "green";
                    }
                    return (
                      <a
                        href="#"
                        className="list-group-item list-group-item-action"
                        key={selectedModulo.value}
                        style={{
                          color: color,
                          background:
                            color === "green"
                              ? "rgb(0,255,0, 0.1)"
                              : color === "red"
                              ? "rgb(255,0,0, 0.1)"
                              : "transparent",
                        }}
                      >
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                            {color === "green"
                              ? `+ Integracion ${selectedModulo.name}`
                              : color === "red"
                              ? `- Integracion ${selectedModulo.name}`
                              : `Integracion ${selectedModulo.name}`}
                          </h5>
                          <small style={{ color: color === "green" || color === "red" ? color : "#999" }}>
                            RD${" "}
                            {
                              // eslint-disable-next-line no-undef
                              Citrus.Convert.toCurrencyNoSimbolo(COSTO_INTEGRACIONES)
                            }
                          </small>
                        </div>
                      </a>
                    );
                  } else {
                    return null;
                  }
                })}
                {panelFirmaDiff?.map((modulo) => {
                  const selectedModulo = integracionesPanelFirma.find((mod) => mod.value === modulo.value);
                  if (selectedModulo) {
                    let color;
                    if (modulo.status === "N") {
                      color = "#495057";
                    } else if (modulo.status === "E") {
                      color = "red";
                    } else if (modulo.status === "A") {
                      color = "green";
                    }
                    return (
                      <>
                        <a
                          href="#"
                          className="list-group-item list-group-item-action"
                          key={selectedModulo.value}
                          style={{
                            color: color,
                            background:
                              color === "green"
                                ? "rgb(0,255,0, 0.1)"
                                : color === "red"
                                ? "rgb(255,0,0, 0.1)"
                                : "transparent",
                          }}
                        >
                          <div className="d-flex w-100 justify-content-between">
                            <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                              {color === "green"
                                ? `+ Panel de firma ${selectedModulo.name}`
                                : color === "red"
                                ? `- Panel de firma ${selectedModulo.name}`
                                : `Panel de firma ${selectedModulo.name}`}
                            </h5>
                            <small style={{ color: color === "green" || color === "red" ? color : "#999" }}>
                              RD${" "}
                              {
                                // eslint-disable-next-line no-undef
                                Citrus.Convert.toCurrencyNoSimbolo(COSTO_INTEGRACIONES)
                              }
                            </small>
                          </div>
                        </a>
                        {modulo.status === "A" && (
                          <a
                            href="#"
                            className="list-group-item list-group-item-action"
                            key={selectedModulo.value}
                            style={{
                              color: color,
                              background:
                                color === "green"
                                  ? "rgb(0,255,0, 0.1)"
                                  : color === "red"
                                  ? "rgb(255,0,0, 0.1)"
                                  : "transparent",
                            }}
                          >
                            <div className="d-flex w-100 justify-content-between">
                              <h5
                                className="mb-1"
                                style={{ width: "70%", display: "flex", flexDirection: "column", color: "green" }}
                              >
                                + Integracion remota {selectedModulo.name}{" "}
                                <small className="text-muted">Pago unico</small>
                              </h5>
                              <small style={{ color: "green" }}>
                                RD${" "}
                                {
                                  // eslint-disable-next-line no-undef
                                  Citrus.Convert.toCurrencyNoSimbolo(4000)
                                }
                              </small>
                            </div>
                          </a>
                        )}
                      </>
                    );
                  } else {
                    return null;
                  }
                })}
                {enlacePagoDiff?.map((modulo) => {
                  const selectedModulo = integracionLinkPago.find((mod) => mod.value === modulo.value);
                  if (selectedModulo) {
                    let color;
                    if (modulo.status === "N") {
                      color = "#495057";
                    } else if (modulo.status === "E") {
                      color = "red";
                    } else if (modulo.status === "A") {
                      color = "green";
                    }
                    return (
                      <a
                        href="#"
                        className="list-group-item list-group-item-action"
                        key={selectedModulo.value}
                        style={{
                          color: color,
                          background:
                            color === "green"
                              ? "rgb(0,255,0, 0.1)"
                              : color === "red"
                              ? "rgb(255,0,0, 0.1)"
                              : "transparent",
                        }}
                      >
                        <div className="d-flex w-100 justify-content-between">
                          <h5 className="mb-1" style={{ width: "70%", display: "flex", flexDirection: "column" }}>
                            {color === "green"
                              ? `+ Integracion ${selectedModulo.name}`
                              : color === "red"
                              ? `- Integracion ${selectedModulo.name}`
                              : `Integracion ${selectedModulo.name}`}
                          </h5>
                          <small style={{ color: color === "green" || color === "red" ? color : "#999" }}>
                            RD${" "}
                            {
                              // eslint-disable-next-line no-undef
                              Citrus.Convert.toCurrencyNoSimbolo(COSTO_INTEGRACIONES)
                            }
                          </small>
                        </div>
                      </a>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
              <div className="d-flex">
                <div style={{ fontSize: "smaller" }}>
                  <SvgComponent
                    iconName="circulo"
                    style={{
                      marginLeft: "3px",
                      marginBottom: "1px",
                    }}
                    fill={"#00ff00"}
                    width="20px"
                    height="20px"
                  />
                  Servicio agregado
                </div>
                <div style={{ fontSize: "smaller" }}>
                  <SvgComponent
                    iconName="circulo"
                    style={{
                      marginLeft: "3px",
                      marginBottom: "1px",
                    }}
                    fill={"#FF0000"}
                    width="20px"
                    height="20px"
                  />
                  Servicio eliminado
                </div>
              </div>
            </EditSection>
          </Col>
        </Row>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="card mb-4 shadow-sm" style={{ width: "100%" }}>
            <div className="card-header">
              <h4 className="my-0 font-weight-normal">Monto a pagar</h4>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <h1 className="card-title pricing-card-title" style={{ fontSize: "1.5rem" }}>
                  Subtotal:
                </h1>
                <h1 className="card-title pricing-card-title" style={{ fontSize: "1.5rem" }}>
                  {pagoAnual
                    ? `RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(montoAnual + pagosUnicos + Math.abs(descuentoAnual) ?? 0)
                      }`
                    : (compania?.CantidadUsuarios ?? 0) + value > 20
                    ? `RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(
                          subTotal + pagosUnicos + Math.abs(descuentoCantidadLicencias) ?? 0
                        )
                      }`
                    : `RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(subTotal + pagosUnicos ?? 0)
                      }`}
                </h1>
              </div>
              <div className="d-flex justify-content-between">
                <h1 className="card-title pricing-card-title" style={{ fontSize: "1.5rem" }}>
                  Descuento:
                </h1>
                <h1 className="card-title pricing-card-title" style={{ fontSize: "1.5rem" }}>
                  {pagoAnual
                    ? `RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(Math.abs(descuentoAnual) ?? 0)
                      }`
                    : (compania?.CantidadUsuarios ?? 0) + value > 20
                    ? `RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(Math.abs(descuentoCantidadLicencias ?? 0))
                      }`
                    : `RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(0)
                      }`}
                </h1>
              </div>
              <div className="d-flex justify-content-between">
                <h1 className="card-title pricing-card-title" style={{ fontSize: "1.5rem" }}>
                  Impuestos:
                </h1>
                <h1 className="card-title pricing-card-title" style={{ fontSize: "1.5rem" }}>
                  {pagoAnual
                    ? ` RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(pagosUnicos * 0.18)
                      }`
                    : ` RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(pagosUnicos * 0.18)
                      }`}
                </h1>
              </div>
              <div className="d-flex justify-content-between">
                <h1 className="card-title pricing-card-title" style={{ fontSize: "1.5rem" }}>
                  Total:
                </h1>
                <h1 className="card-title pricing-card-title" style={{ fontSize: "1.5rem" }}>
                  {pagoAnual
                    ? ` RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(montoAnual + pagosUnicos + pagosUnicos * 0.18)
                      }`
                    : ` RD$${
                        // eslint-disable-next-line no-undef
                        Citrus.Convert.toCurrencyNoSimbolo(subTotal + pagosUnicos + pagosUnicos * 0.18)
                      }`}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center mb-4 flex-column">
          <SelectButton
            pt={{
              button: {
                style: {
                  width: "200px",
                  borderRadius: "6px",
                  border: `1px solid ${theme.color1}`,
                  color: theme.color1,
                  padding: "0.75rem 0.75rem",
                },
              },
            }}
            className="d-flex"
            value={tipoPago}
            options={[
              { name: "Tarjeta", value: 0 },
              { name: "Transferencia Bancaria", value: 1 },
            ]}
            onChange={(e) => setTipoPago(e.value)}
            optionLabel="name"
            id="tipoPago"
          />
        </div>
        <Form.Group>
          <Button
            type="button"
            onClick={() => {
              var modulosEliminadosTemp = [];

              intDGIIDiff?.map((modulo) => {
                if (modulo.status === "E") {
                  const selectedModulo = integracionesDgii.find((mod) => mod.value === modulo.value);
                  modulosEliminadosTemp.push(selectedModulo.name);
                }
              });
              comercioElecDiff?.map((modulo) => {
                if (modulo.status === "E") {
                  const selectedModulo = integracionComernioElectronico.find((mod) => mod.value === modulo.value);
                  modulosEliminadosTemp.push(selectedModulo.name);
                }
              });
              enlacePagoDiff?.map((modulo) => {
                if (modulo.status === "E") {
                  const selectedModulo = integracionLinkPago.find((mod) => mod.value === modulo.value);
                  modulosEliminadosTemp.push(selectedModulo.name);
                }
              });
              panelFirmaDiff?.map((modulo) => {
                if (modulo.status === "E") {
                  const selectedModulo = integracionesPanelFirma.find((mod) => mod.value === modulo.value);
                  modulosEliminadosTemp.push(selectedModulo.name);
                }
              });
              modulosAdicionalesDiff?.map((modulo) => {
                if (modulo.status === "E") {
                  const selectedModulo = modulosAdi.find((mod) => mod.value === modulo.value);
                  modulosEliminadosTemp.push(selectedModulo.name);
                }
              });

              if (modulosEliminadosTemp.length > 0) {
                setModulosEliminados(modulosEliminadosTemp);
                setRazonCancelacionModalVisible(true);
              } else {
                if (subTotal + pagosUnicos + pagosUnicos * 0.18 > 0) {
                  if (tipoPago === 0) {
                    setTarjetaModalVisbile(true);
                  } else if (tipoPago === 1) {
                    enviarComprobanteTransferencia();
                  }
                } else {
                  ActualizarCompania();
                }
              }
            }}
            className="btn btn-success btn-lg form-control"
          >
            Aceptar
          </Button>
        </Form.Group>
      </div>
    );
  };

  useEffect(() => {
    let licencias = opereacion ? (compania?.CantidadUsuarios ?? 0) + value : (compania?.CantidadUsuarios ?? 0) - value;
    setLicenciasERP(licencias < 0 ? 0 : licencias);
    if (opereacion) {
      setClickPlusERP(true);
      setClickMinusERP(false);
    } else {
      setClickPlusERP(false);
      setClickMinusERP(true);
    }
  }, [opereacion]);
  useEffect(() => {
    let licencias = opereacionCRM
      ? (compania?.CantidadUsuariosCRM ?? 0) + valueCRM
      : (compania?.CantidadUsuariosCRM ?? 0) - valueCRM;
    setLicenciasCRM(licencias < 0 ? 0 : licencias);
    if (opereacionCRM) {
      setClickPlusCRM(true);
      setClickMinusCRM(false);
    } else {
      setClickPlusCRM(false);
      setClickMinusCRM(true);
    }
  }, [opereacionCRM]);

  useEffect(() => {
    let licencias = opereacionPT
      ? (compania?.CantidadUsuariosPT ?? 0) + valuePT
      : (compania?.CantidadUsuariosPT ?? 0) - valuePT;
    setLicenciasPT(licencias < 0 ? 0 : licencias);
    if (opereacionPT) {
      setClickPlusPT(true);
      setClickMinusPT(false);
    } else {
      setClickPlusPT(false);
      setClickMinusPT(true);
    }
  }, [opereacionPT]);

  function calculateTotal(pagoAnual, esReferido) {
    let descuentoMultiplier = 1;
    let descuentoAnualMultiplier = pagoAnual ? (esReferido ? 0.8625 : 0.9) : 1;
    const factorCobroRecurrente = Number(politicaCobro?.FactorCobroRecurrente ?? 1) || 1;
    let costoLicenciaUnitario = COSTO_LICENCIA;

    let totalLicenciasErp = costoLicenciaUnitario * (opereacion ? value ?? 0 : 0);
    let totalLicenciasPT = COSTO_LICENCIA_PT * (opereacionPT ? valuePT ?? 0 : 0);
    const costoLicencias =
      costoLicenciaUnitario * (opereacionCRM ? valueCRM ?? 0 : 0) + totalLicenciasErp + totalLicenciasPT;
    setTotalLicencia(costoLicencias);

    const costoModulo = COSTO_MODULOS_ADICIONALES;

    let modAdiDiff = 0;
    modulosAdicionalesDiff?.map((modulo) => {
      if (modulo.status === "A") {
        modAdiDiff += 1;
      }
    });
    let modulosDiff = 0;
    let integracionesDiff = 0;
    intDGIIDiff?.map((modulo) => {
      if (modulo.status === "A" && modulo.value === 2) {
        modulosDiff += 1;
      }
    });
    comercioElecDiff?.map((modulo) => {
      if (modulo.status === "A") {
        integracionesDiff += 1;
      }
    });
    panelFirmaDiff?.map((modulo) => {
      if (modulo.status === "A") {
        integracionesDiff += 1;
      }
    });
    enlacePagoDiff?.map((modulo) => {
      if (modulo.status === "A") {
        integracionesDiff += 1;
      }
    });
    const costoModulos = costoModulo * modAdiDiff;
    let costoIntegraciones = costoModulo * modulosDiff + COSTO_INTEGRACIONES * integracionesDiff;
    const nuevaActivacionEcf =
      intDGII[0] === 1 && configInicial?.intDGII?.[0] !== 1;
    const cobrarImplementacionEcf = politicaCobro?.CobrarImplementacionEcf !== false;
    const costoImplementacionEcf = nuevaActivacionEcf && cobrarImplementacionEcf ? 10000 : 0;
    let pagosUnicos =
      (panelFirma[0] !== null && panelFirma.length > 0 && configInicial?.panelFirma[0] === null ? 4000 : 0) +
      costoImplementacionEcf +
      (intDGII[0] !== null && intDGII.length > 0 && intDGII[0] === 2 && configInicial?.intDGII[0] !== 2 ? 4000 : 0);
    setPagosUnicos(pagosUnicos);
    descuentoMultiplier = pagoAnual && esReferido ? 1 : esReferido ? 0.75 : 1;

    const planSeleccionado = tipoPlanECFDiff
      .map((plan) => planesEcf.find((planes) => plan.value === planes.value && plan.status === "A"))
      .filter(Boolean)[0];
    costoIntegraciones += planSeleccionado && intDGII[0] === 1 ? planSeleccionado.precio ?? 0 : 0;
    if (modulosAdicionalesDiff.find((mod) => mod.value === 4) && opereacionTabletas && valueTabletas > 0) {
      costoIntegraciones += precioTabletas(valueTabletas);
    }
    let subtotal = costoLicencias + costoModulos + costoIntegraciones;
    let montoDescuentoPorCantidadLicencias = subtotal * 0.2;
    if ((compania?.CantidadUsuarios ?? 0) + value > 20) {
      setDescuentoCantidadLicencias(montoDescuentoPorCantidadLicencias);
      subtotal = subtotal * 0.8;
    }
    const subtotalAjustadoPorCiclo = subtotal * factorCobroRecurrente;

    if (tipoPlanReferido === 1) {
      // 25% de descuentos primero 3 meses
      const subTotalConDescuento = subtotalAjustadoPorCiclo * descuentoMultiplier;
      const descuentoAnual = subTotalConDescuento * descuentoAnualMultiplier - subTotalConDescuento;

      setTotalModulos(costoModulos * factorCobroRecurrente);
      setTotalIntegraciones(costoIntegraciones * factorCobroRecurrente);
      setSubtotal(subTotalConDescuento);
      setMontoAnual(subTotalConDescuento * descuentoAnualMultiplier * 12);
      setDescuentoAnual(descuentoAnual * 12);

      if (isFirstRun.current && subTotalConDescuento !== 0) {
        setTotalConfigInicial(subTotalConDescuento);
        isFirstRun.current = false;
      }

      if (esReferido && !pagoAnual) {
        setMontoDescuentoReferencia(subtotal - subTotalConDescuento);
      }
      return {
        subTotal: subTotalConDescuento,
        pagosUnicos,
        totalPendiente: subTotalConDescuento + pagosUnicos + pagosUnicos * 0.18,
      };
    } else {
      // primer mes gratis
      setSubtotal(0);
      const montoAnual = subtotalAjustadoPorCiclo * 12 - subtotalAjustadoPorCiclo;
      if (esReferido && !pagoAnual) {
        setMontoDescuentoReferencia(subtotalAjustadoPorCiclo);
      }
      setMontoAnual(montoAnual * 0.9);
      setDescuentoAnual(montoAnual - montoAnual * 0.9 + subtotalAjustadoPorCiclo);
      setTotalModulos(costoModulos * factorCobroRecurrente);
      setTotalIntegraciones(costoIntegraciones * factorCobroRecurrente);
      return {
        subTotal: 0,
        pagosUnicos,
        totalPendiente: pagosUnicos + pagosUnicos * 0.18,
      };
    }
  }
  useEffect(() => {
    calculateTotal(pagoAnual, false);
  }, [pagoAnual]);
  const onHidePagoModal = () => {
    setPagoModalVisible(false);
  };
  useEffect(() => {
    if (pagoExitoso) {
      setPagoExitoso(false);
      setPagoModalVisible(false);
      setTarjetaModalVisbile(false);
      setTransferenciaBancariaModalVisible(false);
      limpiarFormularioTransferencia();
      ActualizarCompania();
    }
  }, [pagoExitoso]);

  const continuarConRazonCancelacion = () => {
    const razon = mensajeCancelacionRef.current?.value?.trim() ?? "";
    if (!razon) {
      Warning({ message: "Para proceder tiene que escribir su razón de cancelación" });
      return;
    }
    if (razon.length < 5) {
      Warning({ message: "El mensaje es muy corto" });
      return;
    }

    if (subTotal + pagosUnicos + pagosUnicos * 0.18 > 0) {
      if (tipoPago === 0) {
        setTarjetaModalVisbile(true);
        setRazonCancelacionModalVisible(false);
        setPendingCancellationConfig(null);
      } else if (tipoPago === 1) {
        enviarComprobanteTransferencia();
        setRazonCancelacionModalVisible(false);
        setPendingCancellationConfig(null);
      }
    } else {
      setRazonCancelacionModalVisible(false);
      setPendingCancellationConfig(null);
      ActualizarCompania();
    }
  };

  const CancellationReasonDialog = () => {
    if (!razonCancelacionModalVisible) {
      return null;
    }

    const cancellationConfig = pendingCancellationConfig ?? getCancellationConfig(compania);
    const servicios = cancellationConfig?.message ?? "Indícanos la razón de esta cancelación.";
    const modulosTexto = modulosEliminados.length > 0
      ? `También se retirarán: ${modulosEliminados.join(", ")}.`
      : "";
    const cerrar = () => {
      setRazonCancelacionModalVisible(false);
      setPendingCancellationConfig(null);
    };

    return (
      <div className="modal-overlay formalizacion-card-payment-modal mi-cuenta-cancel-modal" role="dialog" aria-modal="true" aria-labelledby="mi-cuenta-cancel-title">
        <div className="modal mi-cuenta-cancel-modal__box mi-cuenta-cancel-modal__box--reason">
          <header className="modal__header">
            <h3 id="mi-cuenta-cancel-title">
              <Icon name="ban" />
              {cancellationConfig?.title ?? "Confirmar cancelación"}
            </h3>
            <button className="modal__close" type="button" onClick={cerrar} aria-label="Cerrar">
              <Icon name="x" />
            </button>
          </header>
          <div className="mi-cuenta-cancel-modal__body">
            <span className="mi-cuenta-cancel-modal__eyebrow">{cancellationConfig?.originLabel ?? "Cancelación solicitada"}</span>
            <p className="mi-cuenta-cancel-modal__lead">{servicios}</p>
            <p className="mi-cuenta-cancel-modal__detail">
              {cancellationConfig?.detail ?? "El equipo de Citrus revisará la solicitud y confirmará el resultado por correo."} {modulosTexto}
            </p>
            <label className="mi-cuenta-cancel-modal__field">
              <span>Motivo de cancelación <b>*</b></span>
              <InputTextarea ref={mensajeCancelacionRef} rows={5} autoResize placeholder="Escribe aquí la razón de la cancelación..." />
            </label>
          </div>
          <footer className="modal__footer mi-cuenta-cancel-modal__footer">
            <button className="btn btn--ghost mi-cuenta-modal-btn mi-cuenta-modal-btn--cancel" type="button" onClick={cerrar}>
              <Icon name="x" />
              No continuar
            </button>
            <button className="btn btn--primary mi-cuenta-modal-btn mi-cuenta-modal-btn--confirm" type="button" onClick={continuarConRazonCancelacion}>
              Confirmar retiro
              <Icon name="check" />
            </button>
          </footer>
        </div>
      </div>
    );
  };

  const limpiarFormularioTransferencia = () => {
    setTipoComprobante("Transferencia");
    setBancoEmisor("");
    setNombre("");
    setFechaTransferencia("");
    setReferencia("");
    setArchivoComprobante(null);
  };

  const validarArchivoTransferencia = (file) => {
    if (!file) {
      return false;
    }
    const allowedTypes = ["application/pdf", "image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      Warning({ message: "Solo se permiten archivos en formato PDF, JPG o PNG." });
      return false;
    }
    if (file.size > 5 * 1024 * 1024) {
      Warning({ message: "El archivo no puede ser mayor a 5MB." });
      return false;
    }
    return true;
  };

  const seleccionarComprobanteTransferencia = (file) => {
    if (validarArchivoTransferencia(file)) {
      setArchivoComprobante(file);
    }
  };

  const enviarComprobanteTransferencia = () => {
    if (!nombre.trim()) {
      Warning({ message: "El campo Nombre es obligatorio." });
      return;
    }
    if (!fechaTransferencia) {
      Warning({ message: "La Fecha de Transferencia o Depósito es obligatoria." });
      return;
    }
    if (!referencia.trim()) {
      Warning({ message: "La Referencia o descripción es obligatoria." });
      return;
    }
    if (!archivoComprobante) {
      Warning({ message: "Debe adjuntar el comprobante de pago para continuar con la solicitud." });
      return;
    }

    setMiCuentaProcessingVisible(true);
    const consultaId = Math.random();
    consultaActualId.current = consultaId;
    const reader = new FileReader();

    reader.onload = function (e) {
      if (consultaId !== consultaActualId.current) {
        return;
      }

      const archivoBase64 = e.target.result.split(",")[1];
      ActualizarCompania({
        ComprobanteTipo: tipoComprobante,
        ComprobanteBancoEmisor: bancoEmisor,
        ComprobanteNombre: nombre,
        ComprobanteFechaTransferencia: fechaTransferencia,
        ComprobanteReferencia: referencia,
        ComprobanteArchivoBase64: archivoBase64,
        ComprobanteNombreArchivo: archivoComprobante.name,
        ComprobanteTipoArchivo: archivoComprobante.type,
        ComprobanteMontoTotal: `${subTotal + pagosUnicos + pagosUnicos * 0.18}`,
      });
    };

    reader.onerror = function () {
      if (consultaId === consultaActualId.current) {
        setMiCuentaProcessingVisible(false);
        Warning({ message: "Error al leer el archivo. Inténtelo nuevamente." });
      }
    };

    reader.readAsDataURL(archivoComprobante);
  };

  const TransferenciaBancariaBody = () => {
    const handleFileSelect = (event) => {
      const file = event.target.files[0];
      if (file) {
        const allowedTypes = ["application/pdf", "image/jpeg", "image/jpg", "image/png"];
        if (!allowedTypes.includes(file.type)) {
          Warning({ message: "Solo se permiten archivos en formato PDF, JPG o PNG." });
          return;
        }

        const maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
          Warning({ message: "El archivo no puede ser mayor a 5MB." });
          return;
        }

        setArchivoComprobante(file);
      }
    };

    const handleDragOver = (event) => {
      event.preventDefault();
    };

    const handleDrop = (event) => {
      event.preventDefault();
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        setArchivoComprobante(files[0]);
      }
    };

    const handleEnviar = async () => {
      setTransferenciaBancariaModalVisible(false);
      enviarComprobanteTransferencia();
    };

    return (
      <div className="bootstrapiso mi-cuenta-config-modal mi-cuenta-config-modal--transfer" style={{ display: "flex", flexDirection: "column", padding: "20px" }}>
        <div style={{ marginBottom: "20px" }}>
          <h4 style={{ fontSize: "18px", fontWeight: "500", marginBottom: "15px", color: "#6c757d" }}>
            Cuenta Bancaria
          </h4>
          <div style={{ fontSize: "14px", lineHeight: "1.6", color: "#495057" }}>
            <div>
              <strong>Banco:</strong> Banco Popular Dominicano
            </div>
            <div>
              <strong>Tipo:</strong> Cuenta Corriente
            </div>
            <div>
              <strong>Número:</strong> 769921859
            </div>
            <div>
              <strong>Propietario:</strong> Citrus Technology Group SRL
            </div>
            <div>
              <strong>RNC:</strong> 130815348
            </div>
          </div>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <h4 style={{ fontSize: "18px", fontWeight: "500", marginBottom: "15px", color: "#6c757d" }}>
            Información de Comprobante
          </h4>

          <div style={{ marginBottom: "15px" }}>
            <label style={{ fontSize: "14px", fontWeight: "500", marginBottom: "5px", display: "block" }}>
              ¿De qué tipo? <span style={{ color: "red" }}>*</span>
            </label>
            <div style={{ display: "flex", gap: "15px" }}>
              <label style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "14px" }}>
                <input
                  type="radio"
                  value="Transferencia"
                  checked={tipoComprobante === "Transferencia"}
                  onChange={(e) => setTipoComprobante(e.target.value)}
                />
                Transferencia
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "14px" }}>
                <input
                  type="radio"
                  value="Depósito"
                  checked={tipoComprobante === "Depósito"}
                  onChange={(e) => setTipoComprobante(e.target.value)}
                />
                Depósito
              </label>
            </div>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label style={{ fontSize: "14px", fontWeight: "500", marginBottom: "5px", display: "block" }}>
              Banco Emisor:
            </label>
            <input
              type="text"
              value={bancoEmisor}
              onChange={(e) => setBancoEmisor(e.target.value)}
              placeholder="Ingrese el banco emisor"
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #ced4da",
                borderRadius: "4px",
                fontSize: "14px",
              }}
            />
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label style={{ fontSize: "14px", fontWeight: "500", marginBottom: "5px", display: "block" }}>
              Nombre: <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ingrese su nombre completo"
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #ced4da",
                borderRadius: "4px",
                fontSize: "14px",
              }}
            />
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label style={{ fontSize: "14px", fontWeight: "500", marginBottom: "5px", display: "block" }}>
              Fecha de Transferencia o Depósito: <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="date"
              value={fechaTransferencia}
              onChange={(e) => setFechaTransferencia(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #ced4da",
                borderRadius: "4px",
                fontSize: "14px",
              }}
            />
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label style={{ fontSize: "14px", fontWeight: "500", marginBottom: "5px", display: "block" }}>
              Referencia o descripción de transferencia o depósito: <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              value={referencia}
              onChange={(e) => setReferencia(e.target.value)}
              placeholder="Ingrese la referencia o descripción"
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #ced4da",
                borderRadius: "4px",
                fontSize: "14px",
              }}
            />
          </div>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
            <h4 style={{ fontSize: "18px", fontWeight: "500", margin: "0", color: "#6c757d" }}>Comprobante</h4>
            <ToolTip message="Información sobre archivo comprobante">
              <div
                onClick={() => setAyudaComprobanteModalVisible(true)}
                style={{
                  marginLeft: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  backgroundColor: "#007bff",
                  color: "white",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ?
              </div>
            </ToolTip>
          </div>
          <p style={{ fontSize: "14px", marginBottom: "10px", color: "#6c757d" }}>
            Seleccione un archivo <span style={{ color: "red" }}>*</span>
          </p>

          <div
            onClick={() => fileInputRef.current?.click()}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            style={{
              border: "2px dashed #007bff",
              borderRadius: "4px",
              padding: "40px 20px",
              textAlign: "center",
              cursor: "pointer",
              backgroundColor: "#f8f9fa",
              marginBottom: "20px",
            }}
          >
            {archivoComprobante ? (
              <div style={{ color: "#28a745", fontSize: "14px" }}>
                <strong>Archivo seleccionado:</strong> {archivoComprobante.name}
              </div>
            ) : (
              <div style={{ color: "#6c757d", fontSize: "14px" }}>Da click o arrastra la imagen para continuar</div>
            )}
          </div>

          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleFileSelect}
            style={{ display: "none" }}
          />
        </div>

        <div style={{ fontSize: "12px", color: "#6c757d", marginBottom: "15px" }}>
          <span style={{ color: "red" }}>*</span> Campos obligatorios
        </div>

        <Button
          className="btn btn-lg"
          type="button"
          style={{
            width: "100%",
            height: "auto",
            backgroundColor: theme.color1,
            borderRadius: "6px",
            borderColor: theme.color1,
            padding: "12px",
          }}
          onClick={handleEnviar}
        >
          Enviar
        </Button>
      </div>
    );
  };

  const AyudaComprobanteBody = () => {
    return (
      <div className="bootstrapiso mi-cuenta-config-modal mi-cuenta-config-modal--help" style={{ display: "flex", flexDirection: "column", padding: "20px" }}>
        <div style={{ marginBottom: "20px" }}>
          <h4 style={{ fontSize: "18px", fontWeight: "500", marginBottom: "15px", color: "#6c757d" }}>
            Información sobre el Comprobante
          </h4>

          <div style={{ marginBottom: "15px" }}>
            <h5 style={{ fontSize: "16px", fontWeight: "500", marginBottom: "10px", color: "#495057" }}>
              Formatos Permitidos:
            </h5>
            <ul style={{ marginLeft: "20px", color: "#495057" }}>
              <li>
                <strong>PDF</strong> (.pdf)
              </li>
              <li>
                <strong>JPG</strong> (.jpg, .jpeg)
              </li>
              <li>
                <strong>PNG</strong> (.png)
              </li>
            </ul>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <h5 style={{ fontSize: "16px", fontWeight: "500", marginBottom: "10px", color: "#495057" }}>
              Tamaño Máximo:
            </h5>
            <p style={{ marginLeft: "20px", color: "#495057", margin: "0" }}>
              <strong>5 MB</strong> por archivo
            </p>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <h5 style={{ fontSize: "16px", fontWeight: "500", marginBottom: "10px", color: "#495057" }}>
              Recomendaciones:
            </h5>
            <ul style={{ marginLeft: "20px", color: "#495057" }}>
              <li>Asegúrese de que el comprobante sea legible</li>
              <li>Incluya toda la información relevante de la transacción</li>
              <li>El archivo debe mostrar claramente la fecha, monto y referencia</li>
            </ul>
          </div>
        </div>

        <Button
          className="btn btn-lg"
          type="button"
          style={{
            width: "100%",
            height: "auto",
            backgroundColor: theme.color1,
            borderRadius: "6px",
            borderColor: theme.color1,
            padding: "12px",
          }}
          onClick={() => setAyudaComprobanteModalVisible(false)}
        >
          Entendido
        </Button>
      </div>
    );
  };

  const obtenerModulosRetirados = () => {
    const retirados = [];
    const agregarRetirado = (diff, catalogo) => {
      diff?.forEach((modulo) => {
        if (modulo.status === "E") {
          const selectedModulo = catalogo.find((mod) => mod.value === modulo.value);
          if (selectedModulo?.name) {
            retirados.push(selectedModulo.name);
          }
        }
      });
    };

    agregarRetirado(intDGIIDiff, integracionesDgii);
    agregarRetirado(comercioElecDiff, integracionComernioElectronico);
    agregarRetirado(enlacePagoDiff, integracionLinkPago);
    agregarRetirado(panelFirmaDiff, integracionesPanelFirma);
    agregarRetirado(modulosAdicionalesDiff, modulosAdi);
    const tabletasInicialRetiro = parseInt(companiaInicial?.CantidadDispositivosAdicionalesRestaurante, 10) || 0;
    if (tabletasInicialRetiro > 0 && totalTabletas < tabletasInicialRetiro) {
      retirados.push("Tabletas adicionales");
    }

    return Array.from(new Set(retirados.filter(Boolean)));
  };

  const getCancellationConfig = (compania, origen = "selector", retiros = []) => {
    const servicios = [
      { active: compania?.CancelarERP ?? false, name: "Citrus ERP" },
      { active: compania?.CancelarCRM ?? false, name: "Citrus CRM" },
      { active: compania?.CancelarPT ?? false, name: "Citrus PT Comercios" },
    ].filter((item) => item.active);

    if (!servicios.length && !retiros.length) {
      return null;
    }

    const nombres = servicios.map((item) => item.name);
    const listaServicios = nombres.length === 1
      ? nombres[0]
      : `${nombres.slice(0, -1).join(", ")} y ${nombres[nombres.length - 1]}`;
    const listaRetiros = retiros.length === 1
      ? retiros[0]
      : `${retiros.slice(0, -1).join(", ")} y ${retiros[retiros.length - 1]}`;
    const title = servicios.length
      ? (nombres.length === 1 ? `Confirmar cancelación de ${listaServicios}` : "Confirmar cancelación de servicios")
      : "Confirmar retiro de servicios";
    const message = [
      servicios.length
        ? `Se solicitará la cancelación de ${listaServicios}.`
        : null,
      retiros.length
        ? `También se retirará: ${listaRetiros}.`
        : null,
    ].filter(Boolean).join(" ");

    return {
      title,
      message,
      detail: "Cuéntanos brevemente el motivo. El equipo de Citrus revisará la solicitud y confirmará el resultado por correo.",
      originLabel: servicios.length ? "Cancelación solicitada" : "Retiro solicitado",
    };
  };

  const handleCancellationConfirm = () => {
    const modulosRetirados = obtenerModulosRetirados();
    const companiaConCancelacionesEfectivas = aplicarCancelacionesForzadasACompania(compania);
    const cancellationConfig = getCancellationConfig(companiaConCancelacionesEfectivas, "aceptar", modulosRetirados);
    const hayCancelacion = Boolean(cancellationConfig);
    const hayCambios = JSON.stringify(configInicial) !== JSON.stringify(newConfig) || hayCancelacion;

    if (!hayCambios) {
        Warning({ message: "Para proceder tiene que realizar al menos un cambio" });
    } else if (hayCancelacion) {
        setModulosEliminados(modulosRetirados);
        setPendingCancellationConfig(cancellationConfig);
        setRazonCancelacionModalVisible(true);
    } else {
        validarLicencias();
    }
  };

  const getCancelacionesForzadasPorLicenciasCero = () => {
    const erpActual = companiaInicial?.CantidadUsuarios ?? compania?.CantidadUsuarios ?? 0;
    const crmActual = companiaInicial?.CantidadUsuariosCRM ?? compania?.CantidadUsuariosCRM ?? 0;
    const ptActual = companiaInicial?.CantidadUsuariosPT ?? compania?.CantidadUsuariosPT ?? 0;
    const erpFinal = Number(newConfig?.licenciasERP ?? licenciasActualesRef.current.erp ?? licenciasERP ?? 0);
    const crmFinal = Number(newConfig?.licencasCRM ?? licenciasActualesRef.current.crm ?? licencasCRM ?? 0);
    const ptFinal = Number(newConfig?.licenciasPT ?? licenciasActualesRef.current.pt ?? licenciasPT ?? 0);
    const forzadas = [];
    if (erpActual > 0 && erpFinal <= 0) {
      forzadas.push(1);
    }
    if (crmActual > 0 && crmFinal <= 0) {
      forzadas.push(2);
    }
    if (ptActual > 0 && ptFinal <= 0) {
      forzadas.push(3);
    }
    return forzadas;
  };

  const getCancelacionesEfectivas = () => getCancelacionesForzadasPorLicenciasCero();

  const aplicarCancelacionesForzadasACompania = (baseCompania = compania) => {
    const cancelacionesEfectivas = getCancelacionesEfectivas();
    return {
      ...(baseCompania || {}),
      CancelarERP: cancelacionesEfectivas.includes(1),
      CancelarCRM: cancelacionesEfectivas.includes(2),
      CancelarPT: cancelacionesEfectivas.includes(3),
    };
  };

  useEffect(() => {
    const cancelacionesEfectivas = getCancelacionesEfectivas();
    const requiereActualizarCompania =
      (compania?.CancelarERP ?? false) !== cancelacionesEfectivas.includes(1) ||
      (compania?.CancelarCRM ?? false) !== cancelacionesEfectivas.includes(2) ||
      (compania?.CancelarPT ?? false) !== cancelacionesEfectivas.includes(3);

    if (requiereActualizarCompania) {
      setCompania(aplicarCancelacionesForzadasACompania(compania));
    }
  }, [licenciasERP, licencasCRM, licenciasPT, newConfig, companiaInicial, compania]);

  const StepIntro = ({ eyebrow, title, body, icon = "pi pi-check-circle", tone = "orange" }) => (
    <div className="formalizar-step-intro">
      <div className={`formalizar-step-icon ${tone}`}>
        <i className={icon} />
      </div>
      <div>
        <span>{eyebrow}</span>
        <h2>{title}</h2>
        <p>{body}</p>
      </div>
    </div>
  );

  const formatMoney = (value) =>
    // eslint-disable-next-line no-undef
    `RD$${Citrus.Convert.toCurrencyNoSimbolo(value || 0)}`;

  const Icon = ({ name }) => {
    const icons = {
      edit: ["M12 20h9", "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"],
      x: ["M18 6 6 18", "M6 6l12 12"],
      "arrow-right": ["M5 12h14", "m12 5 7 7-7 7"],
      paperclip: ["m21.4 11.6-8.5 8.5a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.2 9.2a2 2 0 0 1-2.8-2.8l8.5-8.5"],
      "key-round": ["M2 18a6 6 0 1 0 11-3.3L22 6l-3-3-8.7 8.7A6 6 0 0 0 2 18Z", "M7 17h.01"],
      layers: ["m12 2 9 5-9 5-9-5 9-5Z", "m3 12 9 5 9-5", "m3 17 9 5 9-5"],
      briefcase: ["M10 6V5a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v1", "M3 7h18v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z", "M3 13h18"],
      tablet: ["M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z", "M12 18h.01"],
      users: ["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z", "M22 21v-2a4 4 0 0 0-3-3.87", "M16 3.13a4 4 0 0 1 0 7.75"],
      "file-text": ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z", "M14 2v6h6", "M8 13h8", "M8 17h8", "M8 9h1"],
      file: ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z", "M14 2v6h6"],
      "file-check": ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z", "M14 2v6h6", "m9 15 2 2 4-4"],
      calendar: ["M8 2v4", "M16 2v4", "M3 10h18", "M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"],
      files: ["M20 7h-3a2 2 0 0 1-2-2V2", "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", "M3 7v13a2 2 0 0 0 2 2h10"],
      "folder-tree": ["M20 10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L10 2.6A2 2 0 0 0 8.31 2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16Z", "M2 10v8a2 2 0 0 0 2 2h6", "M10 20h10a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-8l-2 2Z"],
      receipt: ["M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1Z", "M8 7h8", "M8 11h8", "M8 15h5"],
      "pie-chart": ["M21.2 15A9 9 0 1 1 9 2.8V12h9.2", "M12 2.8A9 9 0 0 1 21.2 12H12Z"],
      heart: ["M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"],
      banknote: ["M3 6h18v12H3Z", "M7 12h.01", "M17 12h.01", "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"],
      utensils: ["M4 2v8", "M7 2v8", "M5.5 10v12", "M10 2v20", "M14 2v8a4 4 0 0 0 4 4v8"],
      landmark: ["M3 21h18", "M5 21V10", "M19 21V10", "M12 3 2 8h20Z", "M8 21v-8", "M16 21v-8"],
      factory: ["M3 21h18V9l-6 3V9l-6 3V5H3v16Z", "M7 17h2", "M12 17h2", "M17 17h2"],
      "shopping-cart": ["M6 6h15l-2 8H8L6 3H3", "M9 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", "M18 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"],
      "shopping-bag": ["M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", "M3 6h18", "M16 10a4 4 0 0 1-8 0"],
      hotel: ["M3 21h18", "M4 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16", "M16 11h2a2 2 0 0 1 2 2v8", "M8 7h.01", "M12 7h.01", "M8 11h.01", "M12 11h.01"],
      "credit-card": ["M2 7h20v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2Z", "M2 11h20"],
      cloud: ["M17.5 19H7a5 5 0 1 1 1.1-9.9A7 7 0 0 1 21 13a4 4 0 0 1-3.5 6Z"],
      database: ["M12 3c5 0 9 1.8 9 4s-4 4-9 4-9-1.8-9-4 4-4 9-4Z", "M3 7v5c0 2.2 4 4 9 4s9-1.8 9-4V7", "M3 12v5c0 2.2 4 4 9 4s9-1.8 9-4v-5"],
      mail: ["M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z", "m22 6-10 7L2 6"],
      ban: ["M4.9 4.9a10 10 0 1 0 14.2 14.2A10 10 0 0 0 4.9 4.9Z", "m4.9 4.9 14.2 14.2"],
      monitor: ["M3 4h18v12H3Z", "M8 21h8", "M12 16v5"],
      info: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z", "M12 16v-4", "M12 8h.01"],
      globe: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z", "M2 12h20", "M12 2a15.3 15.3 0 0 1 0 20", "M12 2a15.3 15.3 0 0 0 0 20"],
    };
    return (
      <svg className="mi-cuenta-lucide" viewBox="0 0 24 24" aria-hidden="true">
        {(icons[name] || icons.file).map((path, index) => (
          <path key={`${name}-${index}`} d={path} />
        ))}
      </svg>
    );
  };

  const toggleValue = (values, value) => {
    const currentValues = Array.isArray(values) ? values : [];
    return currentValues.includes(value)
      ? currentValues.filter((item) => item !== value)
      : [...currentValues, value];
  };

  const getModuloMeta = (value) =>
    ({
      1: { title: "Nómina / RRHH", description: "Gestión de personal", icon: "users" },
      2: { title: "Consulta Médica", description: "Gestión clínica", icon: "heart" },
      3: { title: "Factoring", description: "Financiamiento de facturas", icon: "banknote" },
      4: { title: "POS Restaurante", description: "Gestión de Restaurantes", icon: "utensils" },
      5: { title: "Préstamos", description: "Financiamiento y cooperativas", icon: "landmark" },
      6: { title: "Producción", description: "Manufactura y control de producción", icon: "factory" },
    }[value] || {});

  const getConfigMeta = (value) =>
    ({
      1: { title: "Control de Caja", description: "Apertura y Cierre de Caja Diario", icon: "receipt" },
      2: { title: "Centro de Costo", description: "Distribución contable", icon: "pie-chart" },
    }[value] || {});

  const getIntegrationMeta = (group, value) =>
    ({
      dgii: {
        1: { title: "Facturación Electrónica (e-CF)", description: "Activa la gestión y el envío de comprobantes fiscales electrónicos a la DGII desde Citrus ERP.", icon: "file-text" },
      },
      panelFirma: {
        1: { title: "CardNet Panel de Firma", description: "Procesamiento POS CardNet", icon: "credit-card" },
        2: { title: "Portal Panel de Firma", description: "Portal de pagos", icon: "credit-card" },
        3: { title: "Azul Panel de Firma", description: "Procesamiento POS Azul", icon: "credit-card" },
      },
      comercio: {
        1: { title: "WooCommerce", description: "Tienda WooCommerce", icon: "shopping-cart" },
        2: { title: "Shopify", description: "E-commerce Shopify", icon: "shopping-bag" },
        3: { title: "MiniHotel", description: "Gestión hotelera", icon: "hotel" },
      },
      enlace: {
        1: { title: "CardNet Pago en Línea", description: "Pasarela web CardNet", icon: "cloud" },
        2: { title: "Azul Pago en Línea", description: "Pasarela web Azul", icon: "cloud" },
      },
      cancelacion: {
        1: { title: "Citrus ERP", description: "Cancelar servicio administrativo", icon: "ban" },
        2: { title: "Citrus CRM", description: "Cancelar gestión de relaciones", icon: "ban" },
        3: { title: "Citrus PT Comercios", description: "Cancelar POS dispositivos Android", icon: "ban" },
      },
    }[group]?.[value] || {});

  const getEcfPlanIcon = (value) =>
    ({
      "1kT": "file",
      "5kT": "files",
      "10kT": "folder-tree",
      "25kT": "folder-tree",
      "50kT": "folder-tree",
      "100kT": "folder-tree",
    }[value] || "file");

  const SectionHeader = ({ title, badge, hint, badgeTone = "paid" }) => (
    <div className="mi-cuenta-form-section__header">
      <div className="mi-cuenta-form-section__title">{title}</div>
      {badge && <span className={`mi-cuenta-form-section__badge is-${badgeTone}`}>{badge}</span>}
      {hint && <span className="mi-cuenta-form-section__hint">{hint}</span>}
    </div>
  );

  const FormalSwitch = ({ checked, disabled }) => (
    <span className={`mi-cuenta-form-switch ${checked ? "is-on" : ""} ${disabled ? "is-disabled" : ""}`} aria-hidden="true">
      <span />
    </span>
  );

  const ToggleCard = ({ title, description, icon, checked, disabled, danger, onToggle }) => (
    <button
      type="button"
      className={`mi-cuenta-toggle-row ${checked ? "is-active" : ""} ${danger ? "is-danger" : ""} ${disabled ? "is-disabled" : ""}`}
      onClick={disabled ? undefined : onToggle}
      disabled={disabled}
      aria-pressed={checked}
      aria-disabled={disabled}
    >
      <span className="mi-cuenta-toggle-row__info">
        <span className="mi-cuenta-toggle-row__icon">
          <Icon name={icon} />
        </span>
        <span>
          <span className="mi-cuenta-toggle-row__label">{title}</span>
          {description && <span className="mi-cuenta-toggle-row__desc">{description}</span>}
        </span>
      </span>
      <FormalSwitch checked={checked} disabled={disabled} />
    </button>
  );

  const ChoiceCard = ({ title, description, icon, selected, disabled, onClick }) => (
    <button
      type="button"
      className={`mi-cuenta-choice-card ${selected ? "is-selected" : ""}`}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
    >
      <span className="mi-cuenta-choice-card__icon">
        <Icon name={icon} />
      </span>
      <strong>{title}</strong>
      {description && <span>{description}</span>}
    </button>
  );

  const LicenseCard = ({ title, description, icon, current, total, onChange }) => {
    const safeTotal = total ?? current ?? 0;
    const disabled = !editar;
    return (
      <div className={`mi-cuenta-product-tile ${safeTotal > 0 ? "is-active" : ""} ${disabled ? "is-readonly" : ""}`}>
        <div className="mi-cuenta-product-tile__icon">
          <Icon name={icon} />
        </div>
        <div className="mi-cuenta-product-tile__name">{title}</div>
        <div className="mi-cuenta-product-tile__desc">{description}</div>
        <div className="mi-cuenta-product-tile__current">Actuales: {current ?? 0}</div>
        <div className="mi-cuenta-license-counter" aria-label={`${title} licencias`}>
          <button type="button" onClick={() => onChange(safeTotal - 1)} disabled={disabled || safeTotal <= 0}>
            -
          </button>
          <span>{safeTotal}</span>
          <button type="button" onClick={() => onChange(safeTotal + 1)} disabled={disabled || safeTotal >= 100}>
            +
          </button>
        </div>
      </div>
    );
  };

  const setLicenciasServicio = (servicio, siguienteTotal) => {
    if (!editar) {
      return;
    }

    const total = Math.max(0, Math.min(100, siguienteTotal));
    const configuraciones = {
      erp: {
        actual: compania?.CantidadUsuarios ?? 0,
        setOperacion,
        setValor: setValue,
        setTotal: setLicenciasERP,
        configKey: "licenciasERP",
        cancelKey: "CancelarERP",
        refKey: "erp",
      },
      pt: {
        actual: compania?.CantidadUsuariosPT ?? 0,
        setOperacion: setOperacionPT,
        setValor: setValuePT,
        setTotal: setLicenciasPT,
        configKey: "licenciasPT",
        cancelKey: "CancelarPT",
        refKey: "pt",
      },
      crm: {
        actual: compania?.CantidadUsuariosCRM ?? 0,
        setOperacion: setOperacionCRM,
        setValor: setValueCRM,
        setTotal: setLicenciasCRM,
        configKey: "licencasCRM",
        cancelKey: "CancelarCRM",
        refKey: "crm",
      },
    };
    const config = configuraciones[servicio];
    if (!config) {
      return;
    }

    const aumenta = total >= config.actual;
    licenciasActualesRef.current = {
      ...licenciasActualesRef.current,
      [config.refKey]: total,
    };
    setCompania({
      ...compania,
      [config.cancelKey]: total === 0 && config.actual > 0,
    });
    config.setOperacion(aumenta);
    config.setValor(Math.abs(total - config.actual));
    config.setTotal(total);
    setNewConfig({
      ...newConfig,
      [config.configKey]: total,
    });
  };

  const handleModuloToggle = (value) => {
    if (!editar) {
      return;
    }
    const next = toggleValue(modulosAdicionales, value);
    const usaRestaurante = next.includes(4);
    setCompania({
      ...compania,
      _UsaNomina: next.includes(1),
      _UsaConsulta: next.includes(2),
      _UsaFactoring: next.includes(3),
      _usaRestaurante: usaRestaurante,
      _usaPrestamo: next.includes(5),
      _UsaProduccion: next.includes(6),
    });
    if (!usaRestaurante) {
      setTotalTabletas(0);
      setValueTabletas(0);
      setOperacionTabletas(true);
    }
    setModulosAdicionales(next);
    setNewConfig({
      ...newConfig,
      modulosAdicionales: next,
      totalTabletas: usaRestaurante ? totalTabletas : 0,
    });
  };

  const setTabletasAdicionales = (siguienteTotal) => {
    if (!editar) {
      return;
    }
    const total = Math.max(0, Math.min(100, siguienteTotal));
    const actual = parseInt(companiaInicial?.CantidadDispositivosAdicionalesRestaurante, 10) || 0;
    setOperacionTabletas(total >= actual);
    setValueTabletas(Math.abs(total - actual));
    setTotalTabletas(total);
    setNewConfig({
      ...newConfig,
      totalTabletas: total,
    });
  };

  const handleConfigToggle = (value) => {
    if (!editar) {
      return;
    }
    const next = toggleValue(configAdic, value);
    setCompania({
      ...compania,
      _UsaCaja: next.includes(1),
      _UsaCentro: next.includes(2),
    });
    setConfigAdi(next);
    setNewConfig({
      ...newConfig,
      otrasConfig: next,
    });
  };

  const handleDgiiToggle = (value) => {
    if (!editar) {
      return;
    }
    const activo = intDGII[0] === value;
    const ecfActivoEnCuenta = configInicial?.intDGII?.[0] === 1;
    if (ecfActivoEnCuenta && (activo || value !== 1)) {
      Warning({
        message:
          "La Facturación Electrónica (e-CF) activa no puede cancelarse desde Mis Configuraciones. Para solicitar el retiro, comunícate con soporte. Puedes cambiar el plan e-CF desde esta pantalla.",
      });
      return;
    }
    const next = activo ? [] : [value];
    setCompania({
      ...compania,
      _usaFacturacionElectronica: !activo,
      _UsaImpresoraFiscal: false,
      _TipoPlanEcf: !activo ? "1kT" : null,
    });
    setTipoPlan(!activo ? ["1kT"] : []);
    setIntDGII(next);
    setNewConfig({
      ...newConfig,
      intDGII: next,
      tipoPlanECF: !activo ? ["1kT"] : null,
    });
  };

  const handlePanelFirmaToggle = (value) => {
    if (!editar) {
      return;
    }
    const activo = panelFirma[0] === value;
    const nextValue = activo ? null : value;
    setCompania({
      ...compania,
      _UsaVisaNet: nextValue === 2,
      _UsaAzul: nextValue === 3,
      _UsaCardNet: nextValue === 1,
    });
    setPanelFirma(nextValue ? [nextValue] : []);
    setNewConfig({
      ...newConfig,
      panelFirma: nextValue ? [nextValue] : [],
    });
  };

  const handleComercioToggle = (value) => {
    if (!editar) {
      return;
    }
    const next = toggleValue(comercioElec, value);
    setCompania({
      ...compania,
      _UsaShopify: next.includes(2),
      _UsaWooCommerce: next.includes(1),
      _UsaMiniHotel: next.includes(3),
    });
    setComercioElec(next);
    setNewConfig({
      ...newConfig,
      comercioElec: next,
    });
  };

  const handleLinkPagoToggle = (value) => {
    if (!editar) {
      return;
    }
    const next = toggleValue(linkPago, value);
    setCompania({
      ...compania,
      _UsaCardNetEnLinea: next.includes(1),
      _UsaAzulLinkPago: next.includes(2),
    });
    setLinkPago(next);
    setNewConfig({
      ...newConfig,
      linkPago: next,
    });
  };

  const handlePlanEcfChange = (value) => {
    if (!editar) {
      return;
    }
    setCompania({
      ...compania,
      _TipoPlanEcf: value,
    });
    setTipoPlan([value]);
    setNewConfig({
      ...newConfig,
      tipoPlanECF: [value],
    });
  };

  const isAdded = (diff, value) => diff?.some((item) => item.value === value && item.status === "A");
  const selectedAddedEcfPlan = tipoPlanECFDiff
    .map((plan) => planesEcf.find((planes) => plan.value === planes.value && plan.status === "A"))
    .filter(Boolean)[0];
  const agregoTabletas = opereacionTabletas && valueTabletas > 0;
  const costoTabletasAgregadas = agregoTabletas ? precioTabletas(valueTabletas) : 0;
  const getRecurringBaseMonthlySubtotal = () => {
    let subtotalMensual = 0;
    subtotalMensual += opereacion && value > 0 ? COSTO_LICENCIA * value : 0;
    subtotalMensual += opereacionPT && valuePT > 0 ? COSTO_LICENCIA_PT * valuePT : 0;
    subtotalMensual += opereacionCRM && valueCRM > 0 ? COSTO_LICENCIA * valueCRM : 0;
    subtotalMensual += intDGII[0] === 1 && selectedAddedEcfPlan ? selectedAddedEcfPlan.precio ?? 0 : 0;
    subtotalMensual += modulosAdi.filter((item) => isAdded(modulosAdicionalesDiff, item.value)).length * COSTO_MODULOS_ADICIONALES;
    subtotalMensual += costoTabletasAgregadas;
    subtotalMensual += integracionComernioElectronico.filter((item) => isAdded(comercioElecDiff, item.value)).length * COSTO_INTEGRACIONES;
    subtotalMensual += integracionesPanelFirma.filter((item) => isAdded(panelFirmaDiff, item.value)).length * COSTO_INTEGRACIONES;
    subtotalMensual += integracionLinkPago.filter((item) => isAdded(enlacePagoDiff, item.value)).length * COSTO_INTEGRACIONES;
    return subtotalMensual;
  };
  const mesesCobroRecurrente = politicaCobro?.AplicaProrrateo
    ? Number(politicaCobro?.MesesCobro ?? 1) || 1
    : 1;
  const subtotalMensualAntesDescuentos = getRecurringBaseMonthlySubtotal();
  const descuentoVolumenMensual = (compania?.CantidadUsuarios ?? 0) + value > 20
    ? subtotalMensualAntesDescuentos * 0.2
    : 0;
  const subtotalMensualConVolumen = subtotalMensualAntesDescuentos - descuentoVolumenMensual;
  const descuentoVolumenTotal = descuentoVolumenMensual * mesesCobroRecurrente;
  const descuentoCicloRecurrente = politicaCobro?.AplicaDescuentoAnual
    ? subtotalMensualConVolumen * mesesCobroRecurrente * 0.1
    : 0;
  const totalDescuentosPlan = descuentoVolumenTotal + descuentoCicloRecurrente;
  const implementacionEcfNoAplica =
    intDGII[0] === 1 &&
    configInicial?.intDGII?.[0] !== 1 &&
    politicaCobro?.ValidacionEmisorElectronicoRealizada === true &&
    politicaCobro?.EsEmisorElectronico === true &&
    politicaCobro?.CobrarImplementacionEcf === false;
  const totalPendiente = subTotal + pagosUnicos + pagosUnicos * 0.18;
  const tieneCambioConCobro =
    totalLicencia > 0 ||
    totalModulos > 0 ||
    totalIntegraciones > 0 ||
    pagosUnicos > 0;
  const tieneCobroPendiente = editar && tieneCambioConCobro && totalPendiente > 0;

  const formatTransferDate = (date) => {
    if (!date) {
      return "";
    }
    const dateValue = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(dateValue.getTime())) {
      return "";
    }
    const year = dateValue.getFullYear();
    const month = `${dateValue.getMonth() + 1}`.padStart(2, "0");
    const day = `${dateValue.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getTransferDateValue = () => {
    if (!fechaTransferencia) {
      return null;
    }
    const parsedDate = fechaTransferencia instanceof Date
      ? fechaTransferencia
      : new Date(`${fechaTransferencia}T00:00:00`);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  const PlanSummarySection = ({ title, children, highlight }) => (
    <div className={`mi-cuenta-plan-summary__section ${highlight ? "mi-cuenta-plan-summary__section--one-time" : ""}`}>
      <div className="mi-cuenta-plan-summary__label">{title}</div>
      {children}
    </div>
  );

  const PlanSummaryRow = ({ label, amount, note }) => (
    <div className="mi-cuenta-plan-summary__row">
      <span>
        {label}
        {note && <em>{note}</em>}
      </span>
      <strong>{formatMoney(amount)}</strong>
    </div>
  );

  const aplicarMesesCobroRecurrente = (amount) => amount * mesesCobroRecurrente;

  const formatPlanDate = (date) => {
    if (!date) {
      return "";
    }
    const dateValue = new Date(`${date}T00:00:00`);
    if (Number.isNaN(dateValue.getTime())) {
      return "";
    }
    return dateValue.toLocaleDateString("es-DO", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const getRecurringChargeExplanation = () => {
    const factorCobro = Number(politicaCobro?.FactorCobroRecurrente ?? 1) || 1;
    if (!politicaCobro?.AplicaProrrateo || factorCobro <= 1) {
      return null;
    }

    const mesesCobro = Number(politicaCobro?.MesesCobro ?? 1) || 1;
    const programacion = politicaCobro?.ProgramacionDesc || politicaCobro?.Programacion || "no mensual";
    const proximoCiclo = formatPlanDate(politicaCobro?.FechaProximoCiclo);
    const descuento = politicaCobro?.AplicaDescuentoAnual ? " y aplicamos el beneficio de 10% de descuento" : "";
    const cicloTexto = proximoCiclo ? ` hasta tu próximo ciclo de facturación (${proximoCiclo})` : " hasta tu próximo ciclo de facturación";

    return `Tu facturación recurrente es ${programacion}. Para mantener el mismo ciclo, este ajuste se cobra por ${mesesCobro} ${mesesCobro === 1 ? "mes" : "meses"}${cicloTexto}${descuento}.`;
  };

  const PaymentOption = ({ value, icon, title, description }) => (
    <button
      type="button"
      className={`mi-cuenta-pay-opt ${tipoPago === value ? "is-selected" : ""}`}
      onClick={() => setTipoPago(value)}
      role="radio"
      aria-checked={tipoPago === value}
    >
      <span className="mi-cuenta-pay-opt__icon">
        <Icon name={icon} />
      </span>
      <span className="mi-cuenta-pay-opt__name">{title}</span>
      <span className="mi-cuenta-pay-opt__desc">{description}</span>
    </button>
  );

  const TransferInlineDetails = () => (
    <div className="mi-cuenta-transfer-inline">
      <div className="mi-cuenta-transfer-info">
        <Icon name="landmark" />
        <div>
          <strong>Cuenta bancaria Citrus</strong>
          <span><b>Banco:</b> Banco Popular Dominicano</span>
          <span><b>Tipo:</b> Cuenta Corriente</span>
          <span><b>Número:</b> 769921859</span>
          <span><b>Propietario:</b> Citrus Technology Group SRL</span>
          <span><b>RNC:</b> 130815348</span>
        </div>
      </div>
      <div className="mi-cuenta-transfer-field mi-cuenta-transfer-field--full">
        <span>Tipo de comprobante <b>*</b></span>
        <div className="mi-cuenta-transfer-kind">
          <label>
            <input
              type="radio"
              value="Transferencia"
              checked={tipoComprobante === "Transferencia"}
              onChange={(event) => setTipoComprobante(event.target.value)}
            />
            Transferencia
          </label>
          <label>
            <input
              type="radio"
              value="Depósito"
              checked={tipoComprobante === "Depósito"}
              onChange={(event) => setTipoComprobante(event.target.value)}
            />
            Depósito
          </label>
        </div>
      </div>
      <label className="mi-cuenta-transfer-field">
        <span>Banco emisor</span>
        <input
          type="text"
          value={bancoEmisor}
          onChange={(event) => setBancoEmisor(event.target.value)}
          placeholder="Ingrese el banco emisor"
        />
      </label>
      <label className="mi-cuenta-transfer-field">
        <span>Nombre <b>*</b></span>
        <input
          type="text"
          value={nombre}
          onChange={(event) => setNombre(event.target.value)}
          placeholder="Ingrese su nombre completo"
        />
      </label>
      <label className="mi-cuenta-transfer-field">
        <span>Fecha de Transferencia o Depósito <b>*</b></span>
        <div className="mi-cuenta-transfer-date">
          <Calendar
            value={getTransferDateValue()}
            onChange={(event) => setFechaTransferencia(formatTransferDate(event.value))}
            dateFormat="dd/mm/yy"
            mask="99/99/9999"
            locale="es"
            showIcon
            placeholder="DD/MM/AAAA"
          />
        </div>
      </label>
      <label className="mi-cuenta-transfer-field">
        <span>Referencia o descripción <b>*</b></span>
        <input
          type="text"
          value={referencia}
          onChange={(event) => setReferencia(event.target.value)}
          placeholder="Ingrese la referencia o descripción"
        />
      </label>
      <div className="mi-cuenta-transfer-field mi-cuenta-transfer-field--full">
        <span>Adjuntar comprobante de pago <b>*</b></span>
        <div
          className={`mi-cuenta-transfer-dropzone ${archivoComprobante ? "has-file" : ""}`}
          onClick={() => {
            if (!archivoComprobante) {
              fileInputRef.current?.click();
            }
          }}
          onDragOver={(event) => event.preventDefault()}
          onDrop={(event) => {
            event.preventDefault();
            seleccionarComprobanteTransferencia(event.dataTransfer.files?.[0]);
          }}
        >
          {archivoComprobante ? (
            <div className="mi-cuenta-transfer-file">
              <Icon name="file-check" />
              <strong>{archivoComprobante.name}</strong>
              <button
                type="button"
                onClick={(event) => {
                  event.stopPropagation();
                  setArchivoComprobante(null);
                  if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                  }
                }}
              >
                Eliminar
              </button>
            </div>
          ) : (
            <>
              <Icon name="paperclip" />
              <strong>Arrastra o <em>haz clic aquí</em></strong>
              <small>Imagen (PNG, JPG) o PDF · Máx 5 MB</small>
            </>
          )}
          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            onClick={(event) => event.stopPropagation()}
            onChange={(event) => seleccionarComprobanteTransferencia(event.target.files?.[0])}
          />
        </div>
      </div>
    </div>
  );

  const PlanSummary = () => (
    <aside className={`mi-cuenta-plan-rail ${!tieneCobroPendiente ? "is-without-plan" : ""}`}>
      {tieneCobroPendiente && (
        <>
      <div className="mi-cuenta-plan-summary">
        <div className="mi-cuenta-plan-summary__title">
          <Icon name="receipt" />
          <span>Tu plan</span>
        </div>
        {getRecurringChargeExplanation() && (
          <div className="mi-cuenta-plan-summary__notice">
            <Icon name="info" />
            <p>{getRecurringChargeExplanation()}</p>
          </div>
        )}

        {totalLicencia > 0 && (
          <PlanSummarySection title="Licencias">
            {opereacion && value > 0 && <PlanSummaryRow label={`Citrus ERP (${value})`} amount={aplicarMesesCobroRecurrente(COSTO_LICENCIA * value)} />}
            {opereacionPT && valuePT > 0 && <PlanSummaryRow label={`Citrus PT (${valuePT})`} amount={aplicarMesesCobroRecurrente(COSTO_LICENCIA_PT * valuePT)} />}
            {opereacionCRM && valueCRM > 0 && <PlanSummaryRow label={`Citrus CRM (${valueCRM})`} amount={aplicarMesesCobroRecurrente(COSTO_LICENCIA * valueCRM)} />}
          </PlanSummarySection>
        )}

        {intDGII[0] === 1 && selectedAddedEcfPlan && (
          <PlanSummarySection title="Facturación electrónica">
            <PlanSummaryRow label={`Plan e-CF ${selectedAddedEcfPlan.value.replace("T", "").toUpperCase()}`} amount={aplicarMesesCobroRecurrente(selectedAddedEcfPlan.precio)} />
          </PlanSummarySection>
        )}

        {totalModulos > 0 && (
          <PlanSummarySection title="Módulos">
            {modulosAdi
              .filter((item) => isAdded(modulosAdicionalesDiff, item.value))
              .map((item) => (
                <PlanSummaryRow key={item.value} label={getModuloMeta(item.value).title || item.name} amount={aplicarMesesCobroRecurrente(COSTO_MODULOS_ADICIONALES)} />
              ))}
          </PlanSummarySection>
        )}

        {modulosAdicionales.includes(4) && agregoTabletas && (
          <PlanSummarySection title="Tabletas adicionales">
            {descomponerTabletas(valueTabletas).map((linea) => (
              <PlanSummaryRow
                key={linea.cantidad}
                label={linea.veces > 1 ? `Plan ${linea.name} adicionales (${linea.veces})` : `Plan ${linea.name} adicionales`}
                amount={aplicarMesesCobroRecurrente(linea.precio * linea.veces)}
              />
            ))}
          </PlanSummarySection>
        )}

        {(integracionComernioElectronico.some((item) => isAdded(comercioElecDiff, item.value)) ||
          integracionesPanelFirma.some((item) => isAdded(panelFirmaDiff, item.value)) ||
          integracionLinkPago.some((item) => isAdded(enlacePagoDiff, item.value))) && (
          <PlanSummarySection title="Integraciones">
            {integracionComernioElectronico
              .filter((item) => isAdded(comercioElecDiff, item.value))
              .map((item) => (
                <PlanSummaryRow key={`comercio-${item.value}`} label={getIntegrationMeta("comercio", item.value).title || item.name} amount={aplicarMesesCobroRecurrente(COSTO_INTEGRACIONES)} />
              ))}
            {integracionesPanelFirma
              .filter((item) => isAdded(panelFirmaDiff, item.value))
              .map((item) => (
                <PlanSummaryRow key={`panel-${item.value}`} label={getIntegrationMeta("panelFirma", item.value).title || item.name} amount={aplicarMesesCobroRecurrente(COSTO_INTEGRACIONES)} />
              ))}
            {integracionLinkPago
              .filter((item) => isAdded(enlacePagoDiff, item.value))
              .map((item) => (
                <PlanSummaryRow key={`link-${item.value}`} label={getIntegrationMeta("enlace", item.value).title || item.name} amount={aplicarMesesCobroRecurrente(COSTO_INTEGRACIONES)} />
              ))}
          </PlanSummarySection>
        )}

        {(pagosUnicos > 0 || implementacionEcfNoAplica) && (
          <PlanSummarySection title="Costos únicos" highlight>
            {implementacionEcfNoAplica && (
              <PlanSummaryRow
                label="Implementación e-CF no aplica"
                note="RNC validado como emisor electrónico DGII"
                amount={0}
              />
            )}
            {pagosUnicos > 0 && (
              <>
                <PlanSummaryRow label="Implementación y activación" note="pago único" amount={pagosUnicos} />
                <PlanSummaryRow label="ITBIS costos únicos" amount={pagosUnicos * 0.18} />
              </>
            )}
          </PlanSummarySection>
        )}

        <div className="mi-cuenta-plan-summary__divider" />
        {totalDescuentosPlan > 0 && (
          <PlanSummarySection title="Descuentos aplicados">
            {descuentoVolumenTotal > 0 && (
              <PlanSummaryRow label="Descuento por volumen" note="20%" amount={-descuentoVolumenTotal} />
            )}
            {descuentoCicloRecurrente > 0 && (
              <PlanSummaryRow label="Descuento por facturación recurrente" note="10%" amount={-descuentoCicloRecurrente} />
            )}
          </PlanSummarySection>
        )}
        <PlanSummaryRow label="Subtotal" amount={subTotal + pagosUnicos} />
        <div className="mi-cuenta-plan-summary__total">
          <span>
            Total <em>a pagar hoy</em>
          </span>
          <strong>{formatMoney(totalPendiente)}</strong>
        </div>
      </div>

      <div className="mi-cuenta-payment-card">
        <div className="mi-cuenta-payment-card__header">
          <span>
            <Icon name="credit-card" />
          </span>
          <div>
            <h3>Método de pago</h3>
            <p>Elige la opción que más te convenga.</p>
          </div>
        </div>
        <div className="mi-cuenta-pay-grid" role="radiogroup" aria-label="Método de pago">
          <PaymentOption value={0} icon="globe" title="Pago en línea" description="Tarjeta de crédito o débito" />
          <PaymentOption value={1} icon="landmark" title="Transferencia" description="Depósito bancario" />
        </div>
        {tipoPago === 1 && TransferInlineDetails()}
      </div>
        </>
      )}
    </aside>
  );

  const MiCuentaProcessingOverlay = () => {
    if (!miCuentaProcessingVisible) {
      return null;
    }

    const porcentaje = Math.floor(miCuentaProcessingPercent);
    return (
      <div className="mi-cuenta-processing-overlay" role="dialog" aria-modal="true" aria-labelledby="miCuentaProcessingTitle">
        <div className="mi-cuenta-processing-card">
          <div className="mi-cuenta-processing-orange-wrap" aria-hidden="true">
            <img
              className="mi-cuenta-processing-orange"
              src="/Commons/Scripts/Componentes/Formalizar/prototype/wizard/assets/images/citrus-processing-orange.png"
              alt=""
            />
          </div>
          <h2 id="miCuentaProcessingTitle">Procesando modificación</h2>
          <p>Validando la solicitud, preparando los correos y actualizando la configuración.</p>
          <div
            className="mi-cuenta-processing-progress"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow={porcentaje}
            aria-valuetext={`${porcentaje}% completado`}
          >
            <div className="mi-cuenta-processing-progress__bar" style={{ width: `${porcentaje}%` }} />
          </div>
          <div className="mi-cuenta-processing-percent">{porcentaje}%</div>
          <p className="mi-cuenta-processing-note">Por favor, no cierres esta ventana ni actualices la página.</p>
        </div>
      </div>
    );
  };

  return (
    <>
      {MiCuentaProcessingOverlay()}
      {!compania?.Configuracion?.EsCompaniaPrueba && (
        <Container className={`bootstrapiso mi-cuenta-config formalizar-page ${editar ? "mi-cuenta-config--editing" : ""}`}>
          <Dialog
            ref={dialogPagoRef}
            className="mi-cuenta-config-dialog"
            baseZIndex={900002}
            header="Detalles"
            visible={pagoModalVisible}
            style={{ width: "70vw" }}
            breakpoints={{ 1280: "70vw", "960px": "85vw", "641px": "450px", "400px": "350px" }}
            onHide={onHidePagoModal}
            pt={{
              root: { style: { backgroundColor: "#fff" } },
              header: {
                style: {
                  backgroundColor: theme.color1,
                  color: "#fff",
                  borderRadius: "6px",
                  margin: "10px",
                  padding: "10px",
                },
              },
              closeButtonIcon: { style: { color: "#fff" } },
            }}
          >
            {PagoBody()}
          </Dialog>
          <PagoTarjetaFormalizacionDialog
            visible={tarjetaModalVisible}
            onHide={() => setTarjetaModalVisbile(false)}
            setPagoExitoso={setPagoExitoso}
            total={subTotal + pagosUnicos + pagosUnicos * 0.18}
            impuesto={pagosUnicos * 0.18}
            showLoading={() => setMiCuentaProcessingVisible(true)}
            hideLoading={() => setMiCuentaProcessingVisible(false)}
            keepLoadingOnSuccess
          />
          {CancellationReasonDialog()}
          <Dialog
            ref={dialogTransferenciaBancariaRef}
            className="mi-cuenta-config-dialog"
            header="Envío Comprobante de pago"
            visible={transferenciaBancariaModalVisible}
            style={{ width: "50vw" }}
            breakpoints={{ 1280: "70vw", "960px": "85vw", "641px": "450px", "400px": "350px" }}
            onHide={() => {
              setTransferenciaBancariaModalVisible(false);
              limpiarFormularioTransferencia();
            }}
            pt={{
              root: { style: { backgroundColor: "#fff" } },
              header: {
                style: {
                  backgroundColor: theme.color1,
                  color: "#fff",
                  borderRadius: "6px",
                  margin: "10px",
                  padding: "10px",
                },
              },
              closeButtonIcon: { style: { color: "#fff" } },
            }}
          >
            {TransferenciaBancariaBody()}
          </Dialog>
          <Dialog
            ref={dialogAyudaComprobanteRef}
            className="mi-cuenta-config-dialog"
            header="Ayuda - Comprobante"
            visible={ayudaComprobanteModalVisible}
            style={{ width: "40vw" }}
            breakpoints={{ 1280: "50vw", "960px": "70vw", "641px": "90vw", "400px": "95vw" }}
            onHide={() => setAyudaComprobanteModalVisible(false)}
            pt={{
              root: { style: { backgroundColor: "#fff" } },
              header: {
                style: {
                  backgroundColor: theme.color1,
                  color: "#fff",
                  borderRadius: "6px",
                  margin: "10px",
                  padding: "10px",
                },
              },
              closeButtonIcon: { style: { color: "#fff" } },
            }}
          >
            {AyudaComprobanteBody()}
          </Dialog>
          <div className="mi-cuenta-config-page-title">
            <div>
              <h1>Mis configuraciones</h1>
              <p>
                Administra licencias, herramientas, integraciones, facturación electrónica y solicitudes de
                cancelación desde un solo panel.
              </p>
            </div>
            <div className="formalizar-hero-actions">
              {tienePermiso && (
                <AnimatedIconButton
                  onClick={Editar}
                  disabled={estadoFacturacionElectronicaActual?.companiaId !== usuario?.Compania?.Id}
                  iconName={editar ? "x" : "edit"}
                  message={editar ? "Cancelar edición" : "Editar"}
                  size="45px"
                  height="24px"
                  width="24px"
                  id="mi-cuenta-config-edit-icon"
                  style2={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "45px",
                    height: "45px",
                  }}
                />
              )}
              {editar && (
                <AnimatedIconButton
                  onClick={handleCancellationConfirm}
                  iconName="check"
                  message="Aceptar"
                  size="45px"
                  height="24px"
                  width="24px"
                  id="mi-cuenta-config-accept-icon"
                  style2={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "45px",
                    height: "45px",
                  }}
                />
              )}
              {tienePermiso && (
                <ToolTip message={editar ? "Cancelar edición" : "Editar configuración"}>
                  <button
                    className="formalizar-edit-action"
                    type="button"
                    onClick={Editar}
                    disabled={estadoFacturacionElectronicaActual?.companiaId !== usuario?.Compania?.Id}
                  >
                    <Icon name={editar ? "x" : "edit"} />
                    <span>{editar ? "Cancelar edición" : "Editar configuración"}</span>
                  </button>
                </ToolTip>
              )}
              {editar && (
                <ToolTip message="Aceptar cambios">
                  <button className="formalizar-accept-action" type="button" onClick={handleCancellationConfirm}>
                    <Icon name="check" />
                    <span>Aceptar</span>
                  </button>
                </ToolTip>
              )}
            </div>
          </div>

          <div className="formalizar-shell">
            <div className="formalizar-main-panel">
              <div className="layout__content">
                <Stepper>
                  <StepperPanel header="Configuración del servicio">
                    <StepIntro
                      eyebrow="Mis Configuraciones"
                      title="Ajusta tu cuenta Citrus"
                      body="Modifica licencias, módulos, integraciones y cancelaciones con el mismo formato de revisión usado en formalización."
                      icon="pi pi-sliders-h"
                      tone="orange"
                    />
                    <div className="bootstrapiso">
                      <div className="mi-cuenta-formalizacion-config">
                        <div className={`mi-cuenta-config-layout ${tieneCobroPendiente ? "has-side-rail" : ""}`}>
                          <div className="mi-cuenta-config-layout__main">
                        <div className="mi-cuenta-form-card">
                          <div className="mi-cuenta-form-card__header">
                            <span className="mi-cuenta-form-card__icon is-green">
                              <Icon name="key-round" />
                            </span>
                            <div>
                              <h3>Sistemas Citrus</h3>
                              <p>Cada licencia permite el acceso simultáneo de un usuario al sistema.</p>
                            </div>
                          </div>
                          <div className="mi-cuenta-product-grid">
                            <LicenseCard
                              title="Citrus ERP"
                              description="Sistema administrativo"
                              icon="briefcase"
                              current={compania?.CantidadUsuarios ?? 0}
                              total={licenciasERP}
                              onChange={(next) => setLicenciasServicio("erp", next)}
                            />
                            <LicenseCard
                              title="Citrus PT"
                              description="POS dispositivos Android"
                              icon="tablet"
                              current={compania?.CantidadUsuariosPT ?? 0}
                              total={licenciasPT}
                              onChange={(next) => setLicenciasServicio("pt", next)}
                            />
                            <LicenseCard
                              title="Citrus CRM"
                              description="Gestión de relaciones"
                              icon="users"
                              current={compania?.CantidadUsuariosCRM ?? 0}
                              total={licencasCRM}
                              onChange={(next) => setLicenciasServicio("crm", next)}
                            />
                          </div>
                          <div className="mi-cuenta-info-box">
                            <Icon name="info" />
                            <span>Los cambios de licencias se calculan sobre la cantidad actual de tu cuenta.</span>
                          </div>
                        </div>

                        <div className="mi-cuenta-form-card">
                          <div className="mi-cuenta-form-card__header">
                            <span className="mi-cuenta-form-card__icon is-orange">
                              <Icon name="layers" />
                            </span>
                            <div>
                              <h3>Personaliza tu Citrus ERP</h3>
                              <p>Activa o retira los servicios que tu empresa necesite.</p>
                            </div>
                          </div>

                          <div className={`mi-cuenta-ecf-panel ${intDGII[0] === 1 ? "is-active" : ""}`}>
                            {integracionesDgii.map((item) => {
                              const meta = getIntegrationMeta("dgii", item.value);
                              return (
                                <ToggleCard
                                  key={item.value}
                                  title={meta.title || item.name}
                                  description={meta.description}
                                  icon={meta.icon}
                                  checked={intDGII[0] === item.value}
                                  disabled={!editar}
                                  onToggle={() => handleDgiiToggle(item.value)}
                                />
                              );
                            })}
                            {intDGII[0] === 1 && (
                              <div className="mi-cuenta-ecf-plans">
                              <SectionHeader
                                title="Plan e-CF"
                                badge="OBLIGATORIO"
                                hint="Selecciona el volumen mensual de comprobantes electrónicos."
                                badgeTone="integration"
                              />
                              <div className="mi-cuenta-choice-grid">
                                {planesEcf.map((plan) => (
                                  <ChoiceCard
                                    key={plan.value}
                                    title={`Plan ${plan.value.replace("T", "").toUpperCase()}`}
                                    description={plan.label}
                                    icon={getEcfPlanIcon(plan.value)}
                                    selected={tipoPlan[0] === plan.value}
                                    disabled={!editar}
                                    onClick={() => handlePlanEcfChange(plan.value)}
                                  />
                                ))}
                              </div>
                              </div>
                            )}
                          </div>

                          <div className="mi-cuenta-form-section">
                            <SectionHeader
                              title="Herramientas adicionales"
                              badge="GRATIS"
                              hint="Incluidas sin costo adicional con cualquier licencia."
                              badgeTone="free"
                            />
                            <div className="mi-cuenta-modules-grid">
                              {otrasConfig.map((item) => {
                                const meta = getConfigMeta(item.value);
                                return (
                                  <ToggleCard
                                    key={item.value}
                                    title={meta.title || item.name}
                                    description={meta.description}
                                    icon={meta.icon}
                                    checked={configAdic.includes(item.value)}
                                    disabled={!editar}
                                    onToggle={() => handleConfigToggle(item.value)}
                                  />
                                );
                              })}
                            </div>
                          </div>

                          <div className="mi-cuenta-form-section">
                            <SectionHeader
                              title="Módulos adicionales"
                              badge="OPCIONAL"
                              hint="Funcionalidades opciónales según las necesidades de tu empresa."
                            />
                            <div className="mi-cuenta-modules-grid">
                              {modulosAdi.map((item) => {
                                const meta = getModuloMeta(item.value);
                                return (
                                  <ToggleCard
                                    key={item.value}
                                    title={meta.title || item.name}
                                    description={meta.description}
                                    icon={meta.icon}
                                    checked={modulosAdicionales.includes(item.value)}
                                    disabled={!editar}
                                    onToggle={() => handleModuloToggle(item.value)}
                                  />
                                );
                              })}
                            </div>
                          </div>

                          {modulosAdicionales.includes(4) && (
                            <div className="mi-cuenta-addon-panel">
                              <div className="mi-cuenta-info-box">
                                <Icon name="info" />
                                <span>El módulo POS Restaurante incluye 2 tabletas por defecto. Incrementa el plan solo si necesitas dispositivos adicionales.</span>
                              </div>
                              <div className="mi-cuenta-product-grid">
                                <LicenseCard
                                  title="Tabletas Adicionales"
                                  description="Dispositivos POS Restaurante"
                                  icon="tablet"
                                  current={parseInt(compania?.CantidadDispositivosAdicionalesRestaurante, 10) || 0}
                                  total={totalTabletas}
                                  onChange={(next) => setTabletasAdicionales(next)}
                                />
                              </div>
                            </div>
                          )}

                          <div className="mi-cuenta-form-section">
                            <SectionHeader
                              title="Integraciones"
                              badge="OPCIONAL"
                              hint="Conecta Citrus con plataformas y procesadores de pago externos."
                            />
                            <div className="mi-cuenta-modules-grid">
                              {integracionComernioElectronico.map((item) => {
                                const meta = getIntegrationMeta("comercio", item.value);
                                return (
                                  <ToggleCard
                                    key={`comercio-${item.value}`}
                                    title={meta.title || item.name}
                                    description={meta.description}
                                    icon={meta.icon}
                                    checked={comercioElec.includes(item.value)}
                                    disabled={!editar}
                                    onToggle={() => handleComercioToggle(item.value)}
                                  />
                                );
                              })}
                              {integracionesPanelFirma.map((item) => {
                                const meta = getIntegrationMeta("panelFirma", item.value);
                                return (
                                  <ToggleCard
                                    key={`panel-${item.value}`}
                                    title={meta.title || item.name}
                                    description={meta.description}
                                    icon={meta.icon}
                                    checked={panelFirma[0] === item.value}
                                    disabled={!editar}
                                    onToggle={() => handlePanelFirmaToggle(item.value)}
                                  />
                                );
                              })}
                              {integracionLinkPago.map((item) => {
                                const meta = getIntegrationMeta("enlace", item.value);
                                return (
                                  <ToggleCard
                                    key={`link-${item.value}`}
                                    title={meta.title || item.name}
                                    description={meta.description}
                                    icon={meta.icon}
                                    checked={linkPago.includes(item.value)}
                                    disabled={!editar}
                                    onToggle={() => handleLinkPagoToggle(item.value)}
                                  />
                                );
                              })}
                            </div>
                          </div>

                          <div className="mi-cuenta-form-section">
                            <SectionHeader
                              title="Uso incluido"
                              badge="GRATIS"
                              hint="Planes base incluidos en tu servicio."
                              badgeTone="free"
                            />
                            <div className="mi-cuenta-usage-grid">
                              <div className="mi-cuenta-usage-card">
                                <Icon name="database" />
                                <div>
                                  <strong>Plan de Datos</strong>
                                  <span>Uso actual: {usoDatos}</span>
                                  <small>{USO_DATOS[0]?.name}</small>
                                </div>
                              </div>
                              <div className="mi-cuenta-usage-card">
                                <Icon name="mail" />
                                <div>
                                  <strong>Plan Correo Mensual</strong>
                                  <span>Uso actual: {usoCorreoMen}</span>
                                  <small>{USO_CORREOS_MEN[0]?.name}</small>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                          </div>
                          {tieneCobroPendiente && PlanSummary()}
                        </div>
                      </div>
                      {false && (
                      <div className="mi-cuenta-config__legacy" aria-hidden="true">
          <div className="mi-cuenta-config__license-grid d-flex justify-content-around mb-3">
            <div className="mi-cuenta-config__license-card d-flex flex-column align-items-center">
              <h2 className="text-muted">Licencias ERP</h2>
              {editar ? (
                <>
                  <div className="d-flex align-items-center mb-3" style={{ gap: "20px" }}>
                    <p style={{ marginBottom: "0", fontSize: "1.3rem" }}>
                      Actuales: <span style={{ fontWeight: "bold" }}>{compania?.CantidadUsuarios ?? 0}</span>{" "}
                    </p>
                    <div>
                      <AnimatedIconButton
                        size="20px"
                        height="10"
                        width="10"
                        iconName={"plus-crm"}
                        message={`Aumentar`}
                        onClick={() => {
                          setOperacion(true);
                        }}
                        clicked={clickPlusERP}
                        disabled={false}
                      />
                      <AnimatedIconButton
                        size="20px"
                        height="10"
                        width="10"
                        iconName={"minus-crm"}
                        message={`Disminuir`}
                        onClick={() => {
                          setOperacion(false);
                        }}
                        clicked={clickMinusERP}
                        disabled={false}
                      />
                    </div>
                    <InputNumber
                      pt={pt}
                      value={value}
                      size={1}
                      min={0}
                      max={opereacion ? 100 : compania?.CantidadUsuarios ?? 0}
                      onValueChange={(e) => {
                        if (!opereacion && compania?.CantidadUsuarios - e.value <= 0) {
                          Warning({
                            message:
                              "La cantidad de licencias no puede ser 0, si desea eliminar la suscripción para este servicio, marque la opción cancelar Citrus ERP.",
                          });
                          setValue(0);
                        } else {
                          setValue(e.value);
                          let cantLicencias = opereacion
                            ? (compania?.CantidadUsuarios ?? 0) + e.value
                            : (compania?.CantidadUsuarios ?? 0) - e.value;
                          setLicenciasERP(cantLicencias);
                          setNewConfig({
                            ...newConfig,
                            licenciasERP: cantLicencias,
                          });
                        }
                      }}
                      showButtons
                      style={{ width: "3rem" }}
                      decrementButtonClassName="p-button-secondary"
                      incrementButtonClassName="p-button-secondary"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                  </div>
                  <h4>Total de Licencias: {licenciasERP} </h4>
                </>
              ) : (
                <>
                  <h4>{compania?.CantidadUsuarios ?? 0}</h4>
                </>
              )}
            </div>
            <div className="mi-cuenta-config__license-card d-flex flex-column align-items-center">
              <h2 className="text-muted">Licencias PT</h2>
              {editar ? (
                <>
                  <div className="d-flex align-items-center mb-3" style={{ gap: "20px" }}>
                    <p style={{ marginBottom: "0", fontSize: "1.3rem" }}>
                      Actuales: <span style={{ fontWeight: "bold" }}>{compania?.CantidadUsuariosPT ?? 0}</span>{" "}
                    </p>
                    <div>
                      <AnimatedIconButton
                        size="20px"
                        height="10"
                        width="10"
                        iconName={"plus-crm"}
                        message={`Aumentar`}
                        onClick={() => {
                          setOperacionPT(true);
                        }}
                        clicked={clickPlusPT}
                        disabled={false}
                      />
                      <AnimatedIconButton
                        size="20px"
                        height="10"
                        width="10"
                        iconName={"minus-crm"}
                        message={`Disminuir`}
                        onClick={() => {
                          setOperacionPT(false);
                        }}
                        clicked={clickMinusPT}
                        disabled={false}
                      />
                    </div>
                    <InputNumber
                      pt={pt}
                      value={valuePT}
                      size={1}
                      min={0}
                      max={opereacionPT ? 100 : compania?.CantidadUsuariosPT ?? 0}
                      onValueChange={(e) => {
                        if (!opereacionPT && compania?.CantidadUsuariosPT - e.value <= 0) {
                            Warning({
                                message:
                                "La cantidad de licencias no puede ser 0, si desea eliminar la suscripción para este servicio, marque la opción cancelar Citrus PT Comercios.",
                            });
                            setValuePT(0);
                        } else {
                          setValuePT(e.value);
                          let cantLicencias = opereacionPT
                            ? (compania?.CantidadUsuariosPT ?? 0) + e.value
                            : (compania?.CantidadUsuariosPT ?? 0) - e.value;
                          setLicenciasPT(cantLicencias);
                          setNewConfig({
                            ...newConfig,
                            licenciasPT: cantLicencias,
                          });
                        }
                      }}
                      showButtons
                      style={{ width: "3rem" }}
                      decrementButtonClassName="p-button-secondary"
                      incrementButtonClassName="p-button-secondary"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                  </div>
                  <h4>Total de Licencias: {licenciasPT} </h4>
                </>
              ) : (
                <>
                  <h4>{compania?.CantidadUsuariosPT ?? 0}</h4>
                </>
              )}
            </div>
            <div className="mi-cuenta-config__license-card d-flex flex-column align-items-center">
              <h2 className="text-muted">Licencias CRM</h2>
              {editar ? (
                <>
                  <div className="d-flex align-items-center mb-3" style={{ gap: "20px" }}>
                    <p style={{ marginBottom: "0", fontSize: "1.3rem" }}>
                      Actuales: <span style={{ fontWeight: "bold" }}>{compania?.CantidadUsuariosCRM ?? 0}</span>{" "}
                    </p>
                    <div>
                      <AnimatedIconButton
                        size="20px"
                        height="10"
                        width="10"
                        iconName={"plus-crm"}
                        message={`Aumentar`}
                        onClick={() => setOperacionCRM(true)}
                        disabled={false}
                        clicked={clickPlusCRM}
                      />
                      <AnimatedIconButton
                        size="20px"
                        height="10"
                        width="10"
                        iconName={"minus-crm"}
                        message={`Disminuir`}
                        onClick={() => setOperacionCRM(false)}
                        clicked={clickMinusCRM}
                        disabled={false}
                      />
                    </div>
                    <InputNumber
                      pt={pt}
                      value={valueCRM}
                      size={1}
                      min={0}
                      max={opereacionCRM ? 100 : compania?.CantidadUsuariosCRM ?? 0}
                      onValueChange={(e) => {
                        if (
                          !opereacionCRM &&
                          compania?.CantidadUsuariosCRM - e.value <= 0 &&
                          compania?.LicenciaActivaCRM
                        ) {
                          Warning({
                            message:
                              "La cantidad de licencias no puede ser 0, si desea eliminar la suscripción para este servicio, marque la opción cancelar Citrus CRM.",
                          });
                          setValueCRM(0);
                        } else {
                          setValueCRM(e.value);
                          let cantLicencias = opereacionCRM
                            ? (compania?.CantidadUsuariosCRM ?? 0) + e.value
                            : (compania?.CantidadUsuariosCRM ?? 0) - e.value;
                          setLicenciasCRM(cantLicencias);
                          setNewConfig({
                            ...newConfig,
                            licencasCRM: cantLicencias,
                          });
                        }
                      }}
                      showButtons
                      style={{ width: "3rem" }}
                      decrementButtonClassName="p-button-secondary"
                      incrementButtonClassName="p-button-secondary"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                  </div>
                  <h4>Total de Licencias: {licencasCRM} </h4>
                </>
              ) : (
                <>
                  <h4>{compania?.CantidadUsuariosCRM ?? 0}</h4>
                </>
              )}
            </div>
          </div>

          <Row className="mi-cuenta-config__options-row d-flex justify-content-start ">
            <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
              <h4 className="text-muted">Módulos Adicionales</h4>
              <SelectButton
                pt={{
                  button: {
                    style: {
                      width: "130px",
                      border: `1px solid ${theme.color1}`,
                      color: theme.color1,
                      padding: "0.75rem 0.75rem",
                    },
                  },
                  label: { style: { fontSize: "15px" } },
                }}
                onChange={(e) => {
                  setCompania({
                    ...compania,
                    _UsaNomina: e.value.some((item) => item === 1),
                    _UsaConsulta: e.value.some((item) => item === 2),
                    _UsaFactoring: e.value.some((item) => item === 3),
                    _usaRestaurante: e.value.some((item) => item === 4),
                    _usaPrestamo: e.value.some((item) => item === 5),
                    _UsaProduccion: e.value.some((item) => item === 6),
                  });
                  if (!e.value.some((item) => item === 4)) {
                    setTotalTabletas(0);
                    setValueTabletas(0);
                    setOperacionTabletas(true);
                  }
                  setModulosAdicionales(e.value);
                  setNewConfig({
                    ...newConfig,
                    modulosAdicionales: e.value,
                    totalTabletas: e.value.some((item) => item === 4) ? totalTabletas : 0,
                  });
                }}
                className="d-flex"
                id="int-modulosAdi"
                disabled={!editar}
                value={modulosAdicionales}
                options={modulosAdi}
                optionLabel="name"
                multiple
              />
            </Col>

            {modulosAdicionales.find((item) => item === 4) && (
              <>
                <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
                  <h4 className="text-muted text-center">Tabletas Adicionales</h4>
                  <div className="mi-cuenta-license-counter" aria-label="Tabletas adicionales">
                    <button
                      type="button"
                      onClick={() => setTabletasAdicionales(totalTabletas - 1)}
                      disabled={!editar || totalTabletas <= 0}
                    >
                      -
                    </button>
                    <span>{totalTabletas}</span>
                    <button
                      type="button"
                      onClick={() => setTabletasAdicionales(totalTabletas + 1)}
                      disabled={!editar || totalTabletas >= 100}
                    >
                      +
                    </button>
                  </div>
                </Col>
              </>
            )}

            <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
              <h4 className="text-muted">Configuración</h4>
              <SelectButton
                pt={{
                  button: {
                    style: {
                      width: "225px",
                      border: `1px solid ${theme.color1}`,
                      color: theme.color1,
                      padding: "0.75rem 0.75rem",
                    },
                  },
                }}
                onChange={(e) => {
                  setCompania({
                    ...compania,
                    _UsaCaja: e.value.some((item) => item === 1),
                    _UsaCentro: e.value.some((item) => item === 2),
                  });
                  setConfigAdi(e.value);
                  setNewConfig({
                    ...newConfig,
                    otrasConfig: e.value,
                  });
                }}
                className="d-flex"
                id="int-configuracion"
                disabled={!editar}
                value={configAdic}
                options={otrasConfig}
                optionLabel="name"
                multiple
              />
            </Col>
          </Row>

          <Row className="mi-cuenta-config__options-row d-flex justify-content-start">
            <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
              <h4 className="text-muted">Integraciones DGII</h4>
              <SelectButton
                pt={{
                  button: {
                    style: {
                      width: "450px",
                      border: `1px solid ${theme.color1}`,
                      color: theme.color1,
                      padding: "0.75rem 0.75rem",
                      borderRadius: "6px",
                    },
                  },
                }}
                onChange={(e) => {
                  if (configInicial?.intDGII?.[0] === 1 && e.value !== 1) {
                    Warning({
                      message:
                        "La Facturación Electrónica (e-CF) activa no puede cancelarse desde Mis Configuraciones. Para solicitar el retiro, comunícate con soporte. Puedes cambiar el plan e-CF desde esta pantalla.",
                    });
                    return;
                  }
                  setCompania({
                    ...compania,
                    _usaFacturacionElectronica: e.value === 1,
                    _UsaImpresoraFiscal: e.value === 2,
                    _TipoPlanEcf: e.value === 1 ? "1kT" : null,
                  });
                  setTipoPlan(e.value === 1 ? ["1kT"] : []);
                  setIntDGII([e.value]);
                  setNewConfig({
                    ...newConfig,
                    intDGII: [e.value],
                    tipoPlanECF: e.value === 1 ? ["1kT"] : null,
                  });
                }}
                className="d-flex"
                id="int-dgii"
                disabled={!editar}
                value={intDGII[0]}
                options={integracionesDgii}
                optionLabel="name"
              />
            </Col>
            <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
              <h4 className="text-muted">Panel de Firma</h4>
              <SelectButton
                pt={{
                  button: {
                    style: {
                      width: "150px",
                      border: `1px solid ${theme.color1}`,
                      color: theme.color1,
                      padding: "0.75rem 0.75rem",
                    },
                  },
                }}
                onChange={(e) => {
                  setCompania({
                    ...compania,
                    _UsaVisaNet: e.value === 2,
                    _UsaAzul: e.value === 3,
                    _UsaCardNet: e.value === 1,
                  });
                  setPanelFirma([e.value]);
                  setNewConfig({
                    ...newConfig,
                    panelFirma: [e.value],
                  });
                }}
                className="d-flex"
                id="int-panelFirma"
                disabled={!editar}
                value={panelFirma[0]}
                options={integracionesPanelFirma}
                optionLabel="name"
              />
            </Col>
            {intDGII[0] === 1 && (
              <>
                <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
                  <h4 className="text-muted text-center">Planes</h4>
                  <Select
                    isDisabled={!editar}
                    styles={{
                      container: (baseStyles) => ({
                        ...baseStyles,
                        width: "450px",
                        padding: "0px",
                      }),
                    }}
                    className="basic-single"
                    classNamePrefix="select"
                    name="Planes"
                    onChange={(e) => {
                      setCompania({
                        ...compania,
                        _TipoPlanEcf: e.value,
                      });
                      setTipoPlan([e.value]);
                      setNewConfig({
                        ...newConfig,
                        tipoPlanECF: [e.value],
                      });
                    }}
                    options={planesEcf}
                    value={
                      !compania?.TipoPlanECF
                        ? planesEcf.filter(function (option) {
                            return option.value === "1kT";
                          })
                        : planesEcf.filter(function (option) {
                            return option.value === (newConfig?.tipoPlanECF[0] || "1kT");
                          })
                    }
                  />
                </Col>

                <Col className="d-flex flex-column align-items-center mb-3" style={{ opacity: "0" }}>
                  <h4 className="text-muted text-center">Planes</h4>
                  <Select
                    isDisabled={true}
                    styles={{
                      container: (baseStyles) => ({
                        ...baseStyles,
                        padding: "0 15px",
                      }),
                    }}
                    className="basic-single"
                    classNamePrefix="select"
                    name="Planes"
                    onChange={(e) => {
                      setCompania({
                        ...compania,
                        _TipoPlanEcf: e.value,
                      });
                      setTipoPlan([e.value]);
                      setNewConfig({
                        ...newConfig,
                        tipoPlanECF: [e.value],
                      });
                    }}
                    options={planesEcf}
                    value={
                      !compania?.TipoPlanECF
                        ? planesEcf.filter(function (option) {
                            return option.value === "1kT";
                          })
                        : planesEcf.filter(function (option) {
                            return option.value === (newConfig?.tipoPlanECF[0] || "1kT");
                          })
                    }
                  />
                </Col>
              </>
            )}
          </Row>

          <Row className="mi-cuenta-config__options-row d-flex justify-content-around ">
            <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
              <h4 className="text-muted">Comercio Electronico</h4>
              <SelectButton
                pt={{
                  button: {
                    style: {
                      width: "150px",
                      border: `1px solid ${theme.color1}`,
                      color: theme.color1,
                      padding: "0.75rem 0.75rem",
                    },
                  },
                }}
                onChange={(e) => {
                  setCompania({
                    ...compania,
                    _UsaShopify: e.value.some((item) => item === 2),
                    _UsaWooCommerce: e.value.some((item) => item === 1),
                    _UsaMiniHotel: e.value.some((item) => item === 3),
                  });
                  setComercioElec(e.value);
                  setNewConfig({
                    ...newConfig,
                    comercioElec: e.value,
                  });
                }}
                className="d-flex"
                id="int-comercioElec"
                disabled={!editar}
                value={comercioElec}
                options={integracionComernioElectronico}
                optionLabel="name"
                multiple
              />
            </Col>
            <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
              <h4 className="text-muted">Enlace de Pago</h4>
              <SelectButton
                pt={{
                  button: {
                    style: {
                      width: "450px",
                      border: `1px solid ${theme.color1}`,
                      color: theme.color1,
                      borderRadius: "6px",
                    },
                  },
                }}
                onChange={(e) => {
                  setCompania({
                    ...compania,
                    _UsaCardNetEnLinea: e.value.some((item) => item === 1),
                    _UsaAzulLinkPago: e.value.some((item) => item === 2),
                  });
                  setLinkPago(e.value);
                  setNewConfig({
                    ...newConfig,
                    linkPago: e.value,
                  });
                }}
                className="d-flex"
                id="int-enlacePago"
                disabled={!editar}
                value={linkPago}
                options={integracionLinkPago}
                optionLabel="name"
                multiple
              />
            </Col>
          </Row>

          <Row className="mi-cuenta-config__options-row d-flex justify-content-around ">
            <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
              <h4 className="text-muted">Plan de Datos (Uso Actual: {usoDatos})</h4>
              <SelectButton
                pt={{
                  button: {
                    style: {
                      width: "450px",
                      border: `1px solid ${theme.color1}`,
                      color: theme.color1,
                      borderRadius: "6px",
                    },
                  },
                }}
                className="d-flex"
                id="int-totalUsoDatos"
                disabled={true}
                value={1}
                options={USO_DATOS}
                optionLabel="name"
              />
            </Col>
            <Col className="mi-cuenta-config__option-group d-flex flex-column align-items-center mb-3">
              <h4 className="text-muted">Plan Correo Mensual (Uso Actual: {usoCorreoMen})</h4>
              <SelectButton
                pt={{
                  button: {
                    style: {
                      width: "450px",
                      border: `1px solid ${theme.color1}`,
                      color: theme.color1,
                      borderRadius: "6px",
                    },
                  },
                }}
                className="d-flex"
                id="int-totalUsoCorreoMen"
                disabled={true}
                value={1}
                options={USO_CORREOS_MEN}
                optionLabel="name"
              />
            </Col>
          </Row>

          {editar && (
            <Row className="mi-cuenta-config__action-row d-flex justify-content-center">
              <div className="d-flex justify-content-between mb-3">
                <Button
                  type="button"
                  style={{
                    height: "auto",
                    backgroundColor: theme.color1,
                    borderRadius: "6px",
                    borderColor: theme.color1,
                  }}
                  onClick={handleCancellationConfirm}
                  className="btn btn-lg form-control"
                >
                  Aceptar
                </Button>
                <Button
                  type="button"
                  style={{
                    height: "auto",
                    backgroundColor: theme.color1,
                    borderRadius: "6px",
                    borderColor: theme.color1,
                  }}
                  onClick={() => {
                    setEditar(false);
                    setCompania(companiaInicial);
                  }}
                  className="btn btn-lg form-control"
                >
                  Cancelar
                </Button>
              </div>
            </Row>
          )}
                      </div>
                      )}
                    </div>
                  </StepperPanel>
                </Stepper>
              </div>
            </div>
          </div>
        </Container>
      )}
    </>
  );
}




